"use strict";

document.getElementById('svg-container').innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" style="width:0;height:0" visibility="hidden"><symbol id="svg-arr-down" viewBox="0 0 200 200"><path d="M200 71.9L100 172.1 0 71.9"/></symbol><symbol id="svg-arr-right" viewBox="0 0 200 200"><path d="M99.9 0L200 100 99.9 200M0 100h200"/></symbol><symbol id="svg-link-arrow" viewBox="0 0 5 8"><path transform="rotate(-45 0 .707)" d="M0 .707h1v5H0z"/><path transform="rotate(-135 .707 7.071)" d="M.707 7.071h1v5h-1z"/></symbol><symbol id="svg-menu" viewBox="0 0 200 200"><path class="burger__line burger__line--1" d="M0 100h200"/><path class="burger__line burger__line--2" d="M0 100h200"/><path class="burger__line burger__line--3" d="M0 100h200"/></symbol><symbol id="svg-plus" viewBox="0 0 200 200"><path d="M100 0v200M200 100H0"/></symbol><symbol id="svg-search" viewBox="0 0 18 18"><path d="M8.25 14.25a6 6 0 100-12 6 6 0 000 12zM15.75 15.75l-3.262-3.262" stroke="#211E20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></symbol></svg>';
/* globals Raven */

/* eslint moduleName:0 */
"use strict";

(function () {
  var itsoftApp;
  var pageHeader = document.querySelector(".page-header");
  var slice = [].slice;
  var noScript = document.querySelector("[data-no-script]");

  if (noScript) {
    noScript.removeAttribute("data-no-script");
  }

  window.itsoftApp = itsoftApp = {
    createNS: function createNS(namespace) {
      var i, len, nsparts, parent, part;
      nsparts = namespace.split(".");
      parent = itsoftApp; // we want to be able to include or exclude the root namespace so we strip
      // it if it's in the namespace

      if (nsparts[0] === "itsoftApp") {
        nsparts = nsparts.slice(1);
      } // loop through the parts and create a nested namespace if necessary


      for (i = 0, len = nsparts.length; i < len; i++) {
        part = nsparts[i]; // check if the current parent already has the namespace declared
        // if it isn't, then create it

        if (typeof parent[part] === "undefined") {
          parent[part] = {};
        } // get a reference to the deepest element in the hierarchy so far


        parent = parent[part];
      }

      return parent;
    },
    isLocal: !!document.getElementById("js-server-local"),
    utils: {
      debouncer: function debouncer(func, timeout) {
        var timeoutID;

        if (timeout == null) {
          timeout = 200;
        }

        timeoutID = undefined;
        return function () {
          var args, scope;
          scope = this;
          args = arguments;
          clearTimeout(timeoutID);
          timeoutID = setTimeout(function () {
            func.apply(scope, Array.prototype.slice.call(args));
          }, timeout);
        };
      },
      throttler: function throttler(func, ms) {
        var isThrottled = false,
            savedArgs,
            savedThis;

        function wrapper() {
          if (isThrottled) {
            // (2)
            savedArgs = arguments;
            savedThis = this;
            return;
          }

          func.apply(this, arguments); // (1)

          isThrottled = true;
          setTimeout(function () {
            isThrottled = false; // (3)

            if (savedArgs) {
              wrapper.apply(savedThis, savedArgs);
              savedArgs = savedThis = null;
            }
          }, ms);
        }

        return wrapper;
      },
      // Stealed from
      // https://github.com/VodkaBears/Remodal
      getScrollbarWidth: function getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
      },
      // TODO
      // REPAINT
      // Вызывает Recalculate Style
      // Проверить, из-за чего, и можно ли избавиться
      getScrTop: function getScrTop() {
        var $body, $document, $wrapper, scrTop;
        $document = itsoftApp.commonVars.$document;
        $body = itsoftApp.commonVars.$body;
        $wrapper = itsoftApp.commonVars.$wrapper;
        scrTop = Math.max($document.scrollTop, $body.scrollTop, $wrapper.scrollTop, 0); // console.log($document.scrollTop(), $body.scrollTop(), $wrapper.scrollTop())

        return scrTop;
      },
      getTime: function () {
        var res;

        if (window.performance && typeof window.performance.now === "function") {
          res = function res(precision) {
            if (precision == null) {
              precision = 1;
            }

            return parseFloat(window.performance.now().toFixed(precision));
          };
        } else {
          res = function res(precision) {
            if (precision == null) {
              precision = 1;
            }

            return parseFloat(new Date().getTime().toFixed(precision));
          };
        }

        return res;
      }(),
      newMeasureFunc: function newMeasureFunc(precision) {
        var res, t0;

        if (precision == null) {
          precision = 2;
        }

        t0 = itsoftApp.utils.getTime(precision);

        res = function res() {
          var t1, t2;
          t1 = itsoftApp.utils.getTime(precision);
          t2 = parseFloat((t1 - t0).toFixed(precision));
          t0 = t1;
          return t2;
        };

        return res;
      },
      getInitTimes: function getInitTimes() {
        var k, module, obj, ref, total;
        obj = {};
        total = 0;
        ref = itsoftApp.modules;

        for (k in ref) {
          module = ref[k];

          if (module.initialized && module.__mName__ !== undefined) {
            obj[module.__mName__] = module.__initTime__;
            total += module.__initTime__;
          }
        }

        obj.all = Math.round(total);
        return obj;
      },
      checkIsSafari: function checkIsSafari() {
        var UA = navigator.userAgent.toLowerCase();

        if (UA.indexOf("safari") != -1) {
          if (UA.indexOf("chrome") > -1) {
            return;
          } else {
            return true;
          }
        }
      },
      getViewportSize: function getViewportSize() {
        if (itsoftApp.utils.checkIsSafari()) {
          itsoftApp.commonVars.viewWidth = document.documentElement.clientWidth;
        } else {
          itsoftApp.commonVars.viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        }

        return itsoftApp.commonVars.viewWidth;
      },
      getViewportHeight: function getViewportHeight() {
        itsoftApp.commonVars.viewHeight = document.documentElement.clientHeight;
        return itsoftApp.commonVars.viewHeight;
      },
      getHeaderHeight: function getHeaderHeight() {
        itsoftApp.commonVars.headerHeight = pageHeader.offsetHeight;
        return itsoftApp.commonVars.headerHeight;
      },
      getCoords: function getCoords(el) {
        var box = el.getBoundingClientRect();
        return {
          top: box.top + pageYOffset,
          left: box.left + pageXOffset
        };
      }
    },
    loadScript: function loadScript(url, callback, error) {
      var script;
      script = document.createElement("script"); // If "fallback" url passed as second argument

      var args = Array.prototype.slice.call(arguments);

      if (typeof callback === "string") {
        var fallbackUrl = callback;
        callback = error;
        var errorOri = args[3];

        error = function error() {
          DEBUG && console.log("%c[common] error while loading script: " + url + ". trying to load a fallback url: " + fallbackUrl, "color: red");
          itsoftApp.loadScript(fallbackUrl, callback, errorOri);

          if (!DEBUG && typeof Raven !== "undefined") {
            Raven.captureMessage("[common] error while loading script", {
              level: "warning",
              // one of 'info', 'warning', or 'error'
              extra: {
                "script": url,
                "fallback": fallbackUrl
              }
            });
          }
        };
      }

      var cb = function cb() {
        DEBUG && console.log("%c--[common] finished loading script: " + url, "color: #999");

        if (typeof callback === "function") {
          callback();
        }
      }; // IE


      if (script.readyState) {
        script.onreadystatechange = function () {
          if (script.readyState === "loaded" || script.readyState === "complete") {
            script.onreadystatechange = null;
            cb();
          }
        }; // Normal browsers

      } else {
        if (typeof error === "function") {
          script.onerror = error;
        }

        script.onload = cb;
      }

      script.src = url;
      document.getElementsByTagName("body")[0].appendChild(script);
      DEBUG && console.log("%c--[common] starting to load script: " + url, "color: #999");
    },
    loadStyle: function loadStyle(url) {
      var first, head, link;
      link = document.createElement("link");
      link.href = url;
      link.rel = "stylesheet";
      link.type = "text/css";
      head = document.getElementsByTagName("head")[0];
      first = head.firstChild; // Prepend styles in 'head' section

      head.insertBefore(link, first);
    },
    features: {
      // From Modernizr
      transitionEventEnd: function () {
        var el, t, transitions;
        el = document.createElement("fakeelement");
        transitions = {
          "transition": "transitionend",
          "OTransition": "oTransitionEnd",
          "MozTransition": "transitionend",
          "WebkitTransition": "webkitTransitionEnd"
        };

        for (t in transitions) {
          if (el.style[t] !== undefined) {
            el = null;
            return transitions[t];
          }
        }

        return false;
      }()
    },
    modules: {},
    initializedModules: [],
    createModule: function createModule() {
      var dep, dependencies, i, initFunc, j, len, mName, module, options, ref;
      mName = arguments[0], options = 3 <= arguments.length ? slice.call(arguments, 1, i = arguments.length - 1) : (i = 1, []), initFunc = arguments[i++];

      if (typeof initFunc !== "function") {
        throw "Missing an initialization function for module '" + mName + "'";
      } // Create a namespace


      module = itsoftApp.createNS("modules." + mName);
      module.__mName__ = mName;
      module.initialized = false; // Set dependencies

      if (options.length && options[0].length) {
        dependencies = [];
        ref = options[0];

        for (j = 0, len = ref.length; j < len; j++) {
          dep = ref[j];

          if (typeof dep === "string" && dependencies.indexOf(dep) < 0 && dep !== mName) {
            dependencies.push(dep);
          }
        }

        if (dependencies.length) {
          module.dependencies = dependencies;
        }
      } // Set initialization function and behavior


      module.init = function () {
        var depModule, e, initTime, initializedModules, l, len1, t1, t2;

        try {
          if (module.dependencies) {
            for (l = 0, len1 = dependencies.length; l < len1; l++) {
              dep = dependencies[l];
              depModule = itsoftApp.modules[dep];

              if (!depModule) {
                DEBUG && console.log("%c[modules] missed module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
                return false;
              }

              if (depModule.initialized) {
                continue;
              }

              depModule.init();

              if (!depModule.initialized) {
                DEBUG && console.log("%c[modules] can't init module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
                return false;
              }
            }
          }

          t1 = itsoftApp.utils.getTime();

          if (initFunc.call(module) !== false) {
            t2 = itsoftApp.utils.getTime();
            initTime = parseFloat((t2 - t1).toFixed(1));
            module.__initTime__ = initTime;
            DEBUG && console.log("[module " + mName + "] module initialized in " + initTime + " ms");
            module.initialized = true;
            initializedModules = itsoftApp.initializedModules || [];
            initializedModules.push(mName);
            itsoftApp.initializedModules = initializedModules;
          }
        } catch (error1) {
          e = error1;

          if (typeof Raven !== "undefined") {
            Raven.captureException(e);
          }

          itsoftApp.errorHandler(e, {
            moduleName: mName
          });
        }
      };

      return module;
    },
    errorHandler: function errorHandler(error, options) {
      var pre;
      pre = "[error]";

      if (options && options.moduleName) {
        pre += "[module " + options.moduleName + "]";
      }

      if (console && console.error) {
        console.error(pre + "\n" + error + "\nNavigator: " + window.navigator.userAgent);
      }
    }
  }; // Unit-tests for itsoftApp object

  if (DEBUG && typeof mocha !== "undefined" && typeof describe === "function") {
    mocha.setup("bdd");
    describe("itsoftApp object tests", function () {
      it("Should be an object", function () {
        expect(itsoftApp).to.be.an("object");
      });
      it("Should contain a loadScript function", function () {
        expect(itsoftApp.loadScript).to.be.a("function");
      });
      it("Should contain a loadStyle function", function () {
        expect(itsoftApp.loadStyle).to.be.a("function");
      });
      it("We can create a deep namespace scope with a string like 'ns1.ns2.ns3'", function () {
        itsoftApp.createNS("ns1.ns2.ns3");
        expect(itsoftApp.ns1).to.be.an("object");
        expect(itsoftApp.ns1.ns2).to.be.an("object");
        expect(itsoftApp.ns1.ns2.ns3).to.be.an("object");
        delete itsoftApp.ns1;
      });
      it("initializedModules must be defined from the start", function () {
        expect(itsoftApp.initializedModules).to.be.an("array");
      });
      describe(".modules", function () {
        it("Should be a function to create modules", function () {
          expect(itsoftApp.createModule).to.be.a("function");
        });
        it("We can simply create a single module", function () {
          var module, testFunc;

          testFunc = function testFunc() {
            console.log("test module init");
          };

          var mName = "testmodule" + Math.round(Math.random() * 100);
          module = itsoftApp.createModule(mName, testFunc);
          expect(module).to.be.equal(itsoftApp.modules[mName]);
          itsoftApp.initializedModules.splice(itsoftApp.initializedModules.indexOf(mName), 1);
          delete itsoftApp.modules[mName];
        });
        it("We can't create a module without initialization function", function () {
          var module;

          module = function module() {
            itsoftApp.createModule("testmodule");
          };

          expect(module).to["throw"];
        });
        it("Each module must have an init function", function () {
          var module;

          for (module in itsoftApp.modules) {
            expect(itsoftApp.modules[module].init).to.be.a("function");
          }
        });
        it("Should throw an exception if we try to initialize a module twice", function () {
          var mName, module, testFunc;
          mName = "testmodule" + Math.round(Math.random() * 100);

          testFunc = function testFunc() {
            return 1;
          };

          module = itsoftApp.createModule(mName, testFunc);
          module.init();
          expect(module.init).to["throw"];
          itsoftApp.initializedModules.splice(itsoftApp.initializedModules.indexOf(mName), 1);
          delete itsoftApp.modules[mName];
        });
      });
    });
  }

  var itsoftAppInitFunc = function itsoftAppInitFunc() {
    var init = function init() {
      itsoftApp.commonVars = {
        $document: document.documentElement,
        $body: document.body,
        $window: window,
        $wrapper: document.querySelector(".l-wrapper"),
        headerHeight: undefined,
        viewWidth: undefined,
        viewHeight: undefined
      };
      var benchmarkCloseBtn, benchmarkDiv, criticalInitTime, dColor, fTime, initTimes, m, module, moduleName, t, time, warningModules;

      if (DEBUG) {
        t = itsoftApp.utils.getTime();
      }

      itsoftApp.ajaxDisabled = false; //нужно для работы с аяксовыми переходами.

      itsoftApp.removeAllModules = function () {
        for (m in itsoftApp.modules) {
          module = itsoftApp.modules[m];
          module.initialized = false;
        }

        itsoftApp.initializedModules = [];
        DEBUG && console.log("%c[common] all modules removed", "font-weight: bold;");
      };

      itsoftApp.initAllModules = function () {
        // Initialize itsoftApp modules
        itsoftApp.removeAllModules();

        for (m in itsoftApp.modules) {
          module = itsoftApp.modules[m];

          if (!module.initialized && typeof module.init === "function") {
            module.init();
          }
        }
      };

      itsoftApp.initAllModules();

      if (DEBUG) {
        fTime = Math.round(itsoftApp.utils.getTime() - t);
        dColor = fTime < 200 ? "green" : "red";
        console.log("%c[common] document ready event fired, " + itsoftApp.initializedModules.length + " modules initialized in " + fTime + " ms: " + function () {
          var i, len, ref, results;
          ref = itsoftApp.initializedModules;
          results = [];

          for (i = 0, len = ref.length; i < len; i++) {
            m = ref[i];
            results.push(" " + m + "(" + itsoftApp.modules[m].__initTime__ + "ms)");
          }

          return results;
        }(), "color: " + dColor);
      } // Add benchmark div


      benchmarkDiv = document.getElementById("benchmark");

      if (typeof itsoftApp.utils.getInitTimes === "function" && (DEBUG || window.location.hash === "#benchmark") && !benchmarkDiv) {
        benchmarkDiv = document.createElement("div");
        benchmarkDiv.className = "benchmark";
        benchmarkDiv.id = "benchmark";

        if (typeof itsoftApp.utils.getInitTimes === "function") {
          benchmarkDiv.innerHTML = "<small style=\"opacity: 0.7\">modules (ms):" + function () {
            var ref, results;
            ref = itsoftApp.utils.getInitTimes();
            results = [];

            for (m in ref) {
              t = ref[m];
              results.push(" " + m + ": " + t);
            }

            return results;
          }() + "</small>";
        } // Add close button


        benchmarkCloseBtn = document.createElement("a");

        benchmarkCloseBtn.onclick = function () {
          benchmarkDiv.parentNode.removeChild(benchmarkDiv);
        };

        benchmarkCloseBtn.innerHTML = "X";
        benchmarkCloseBtn.className = "benchmark__close";
        benchmarkDiv.appendChild(benchmarkCloseBtn);
        document.body.appendChild(benchmarkDiv);
      } // Check for "too complex" modules
      // WARNING иногда такие "ошибки" возникают спонтанно
      // (например, все модули инициализируются за 0-2 мс, а один "выстрелил" на 300 мс).
      // Если это станет мешать проектам, то можно данные предупреждения
      // из логгера убрать.


      if (!DEBUG && typeof Raven !== "undefined") {
        initTimes = itsoftApp.utils.getInitTimes();
        warningModules = [];
        criticalInitTime = 50;

        for (moduleName in initTimes) {
          time = initTimes[moduleName];

          if (moduleName === "all") {
            continue;
          }

          if (time > criticalInitTime) {
            warningModules.push(moduleName);
          }
        } //  CHANGED: Вот именно из-за того, что один из модулей может
        //  случайно инициализироваться за какое-то неадекватно большое для него время.
        //  if warningModules.length > 0


        if (warningModules.length > 1) {
          Raven.captureMessage("[common] detected some \"long\" (initTime > " + criticalInitTime + " ms) modules", {
            level: "warning",
            // one of 'info', 'warning', or 'error'
            extra: initTimes
          });
        }
      } // If unit tests library loaded, just load a file with tests


      if (typeof mocha !== "undefined") {
        mocha.setup("bdd");
        mocha.run();
      }
    };

    if ("addEventListener" in document) {
      init();
    }
  }; // Document ready event


  if ("addEventListener" in document) {
    document.addEventListener("DOMContentLoaded", itsoftAppInitFunc, false); // .. IE <= 8
  } else if ("attachEvent" in document) {
    document.attachEvent("onreadystatechange", function () {
      if (document.readyState === "complete") {
        itsoftAppInitFunc();
      }
    });
  }
})();
"use strict";

itsoftApp.createModule("accordion", function () {
  var module = this;

  var AccordionItem = function AccordionItem(accordionItemElement, ACCORDION) {
    this.ACCORDION = ACCORDION;
    this.state = {
      opened: accordionItemElement.classList.contains("js-accordion-item--active")
    };
    this.accordionItemElement = accordionItemElement;
    this.accordionHeadElement = accordionItemElement.querySelector(".js-accordion-head");
    this.accordionContentElement = accordionItemElement.querySelector(".js-accordion-content");
    this.accordionText = accordionItemElement.querySelector(".js-accordion-text");
    this.preventNone = this.accordionHeadElement.hasAttribute("data-prevent-none");
    this.once = this.accordionHeadElement.hasAttribute("data-once");
    this.init();
  };

  AccordionItem.prototype.init = function () {
    var ACCORDION_ITEM = this;
    this.openListener = ACCORDION_ITEM.onOpenTransitionEnd.bind(ACCORDION_ITEM);
    this.closeListener = ACCORDION_ITEM.onCloseTransitionEnd.bind(ACCORDION_ITEM);
    this.accordionHeadElement.addEventListener("click", ACCORDION_ITEM.onAccordionClick.bind(ACCORDION_ITEM));
  };

  AccordionItem.prototype.onAccordionClick = function (evt) {
    if (!this.preventNone) {
      /* если специально не указан атрибут data-prevent-none, отменяем действие по умолчанию, например, переход по ссылке */
      evt.preventDefault();
    }
    /* если элемент аккордеона уже активен, скрываем его... */


    if (this.state.opened && this.ACCORDION.currentClosedItem == false) {
      this.ACCORDION.currentClosedItem = this.ACCORDION.activeItem;
      this.ACCORDION.activeItems.splice(this.ACCORDION.activeItems.indexOf(this.ACCORDION.activeItem), 1);
      this.ACCORDION.activeItem = "";
      this.closeAccordion(); // if (this.ACCORDION.accordionType !== "any" && this.ACCORDION.activeItems.length === 0) {

      if (this.ACCORDION.activeItems.length === 0) {
        this.ACCORDION.state.opened = false;
        this.ACCORDION.accordion.classList.remove("js-accordion--active");
      }
      /* ...иначе показываем */

    } else {
      /* если одновременно может быть раскрыт только один элемент, то есть нет атрибута data-type со значением any... */
      if (this.ACCORDION.accordionType !== "any") {
        /*...находим ранее активный элемент и скрываем его */
        if (this.ACCORDION.activeItem && this.ACCORDION.currentClosedItem == false) {
          this.ACCORDION.currentClosedItem = this.ACCORDION.activeItem;
          this.ACCORDION.activeItems.splice(this.ACCORDION.activeItems.indexOf(this.ACCORDION.activeItem), 1);
          this.ACCORDION.activeItem = "";
          this.ACCORDION.currentClosedItem.closeAccordion(); // Закрываем не текущий, а ранее активный элемент аккордеона
        }
      }
      /* показываем элемент, по которому был осуществлён клик */


      if (this.ACCORDION.currentOpenedItem == false) {
        this.ACCORDION.currentOpenedItem = this;
        this.openAccordion();

        if (!this.ACCORDION.state) {
          this.ACCORDION.state.opened = true;
          this.ACCORDION.accordion.classList.add("js-accordion--active");
        }

        if (this.ACCORDION.activeItems.length === this.ACCORDION.allItems.length && !this.ACCORDION.state.openedAll) {
          this.ACCORDION.state.openedAll = true;
        } else if (this.ACCORDION.activeItems.length < this.ACCORDION.allItems.length && this.ACCORDION.state.openedAll) {
          this.ACCORDION.state.openedAll = false;
        }
      }
    }
    /* если есть атрибут data-once, то клик по элементу аккордеона отлавливается только один раз, то есть его нельзя закрыть */


    if (this.once) {
      accordionHeadElement.removeEventListener("click", this.onAccordionClick.bind(this));
    }
  };

  AccordionItem.prototype.closeAccordion = function () {
    var ACCORDION_ITEM = this;
    var closedText = this.accordionItemElement.getAttribute("data-closed-text"); // todo: Проверить работу

    var height = this.accordionContentElement.clientHeight + "px";
    this.accordionItemElement.classList.add("js-accordion-item--close-ready");
    this.accordionContentElement.style.height = height;

    if (closedText) {
      this.accordionText.textContent = closedText; // TODO: Проверить работу
    }

    if (getComputedStyle(this.accordionContentElement).transition) {
      // TODO: доработать, так как отрицательно влияет на рендеринг
      this.accordionContentElement.addEventListener("transitionend", this.closeListener);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          ACCORDION_ITEM.accordionContentElement.style.height = "0px";
        });
      });
    } else {
      ACCORDION_ITEM.accordionContentElement.style.height = "0px";
      this.onCloseTransitionEnd();
    }
  };

  AccordionItem.prototype.onCloseTransitionEnd = function () {
    // стили находятся в файле /assets/styles/page.styl
    this.accordionItemElement.classList.remove("js-accordion-item--active");
    this.accordionItemElement.classList.remove("js-accordion-item--close-ready");
    this.accordionContentElement.removeEventListener("transitionend", this.closeListener); // if (this.ACCORDION.accordionType !== "any") {

    this.ACCORDION.currentClosedItem = ""; // }

    this.state.opened = false;
  };

  AccordionItem.prototype.openAccordion = function () {
    var ACCORDION = this;
    var openedText = this.accordionItemElement.getAttribute("data-opened-text"); //todo: проверить

    /* если есть атрибут со значением, заменяем название элемента аакордеона во время открытия */

    if (openedText) {
      this.accordionText.textContent = openedText; // todo: проверить
    }

    this.accordionItemElement.classList.add("js-accordion-item--open-ready");
    this.accordionContentElement.style.height = "auto";
    var height = this.accordionContentElement.clientHeight + "px";
    this.accordionContentElement.style.height = "0px";

    if (getComputedStyle(this.accordionContentElement).transition) {
      // TODO: доработать, так как отрицательно влияет на рендеринг
      this.accordionContentElement.addEventListener("transitionend", this.openListener);
      /* чтобы была анимация открытия */

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          ACCORDION.accordionContentElement.style.height = height;
        });
      });
    } else {
      ACCORDION.accordionContentElement.style.height = height;
      this.onOpenTransitionEnd();
    }
  };

  AccordionItem.prototype.onOpenTransitionEnd = function () {
    // стили находятся в файле /assets/styles/page.styl

    /* если одноврменно может быть показан только один элемент аккордеона, то добавляем другую анимацию,
    //     чтобы раскрытый аккордеон не ушел за пределы экрана из-за прокрутки страницы */
    this.accordionItemElement.classList.remove("js-accordion-item--open-ready");
    this.accordionItemElement.classList.add("js-accordion-item--active");
    this.accordionContentElement.removeEventListener("transitionend", this.openListener); // if (this.ACCORDION.accordionType !== "any") {

    this.ACCORDION.activeItem = this;
    this.ACCORDION.activeItems.push(this);
    this.ACCORDION.currentOpenedItem = ""; // }

    this.state.opened = true;
  };

  var Accordion = function Accordion(accordion) {
    this.state = {
      opened: false,
      openedAll: false
    }, this.accordion = accordion;
    this.accordionType = accordion.getAttribute("data-type");
    this.accordionItemElements = accordion.querySelectorAll(".js-accordion-item");
    this.accordionHeadElements = accordion.querySelectorAll(".js-accordion-head");
    this.allItems = [];
    this.activeItems = [];
    this.activeItem = "";
    this.activeAccordionContent = "";
    this.currentItem = "";
    this.currentOpenedItem = "";
    this.currentClosedItem = "";
    this.currentOpenedContent = "";
    this.currentClosedContent = "";
    this.init();
  };

  Accordion.prototype.init = function () {
    /* Добавляет каждому элементу аккордеона обработчик события клика */
    var ACCORDION = this;
    Array.from(ACCORDION.accordionItemElements).forEach(function (el) {
      var accordionItem = new AccordionItem(el, ACCORDION);
      ACCORDION.allItems.push(accordionItem);

      if (accordionItem.state.opened) {
        ACCORDION.activeItems.push(accordionItem); // if (ACCORDION.accordionType !== "any") { // todo: Обязательно протестировать этот момент

        ACCORDION.activeItem = accordionItem; // }
      }
    });
    var debouncedUpdate = itsoftApp.utils.debouncer(function () {
      if (ACCORDION.accordion.classList.contains("js-accordion--active")) {
        Array.prototype.forEach.call(ACCORDION.activeItems, function (el) {
          var content = el.accordionContentElement;
          content.style.height = "auto";
          var height = content.clientHeight + "px";
          content.style.height = height;
        });
      }
    }, 500);
    itsoftApp.modules.windowResize.addEvent(function () {
      debouncedUpdate();
    });
  };

  module.callback = Accordion;
});
"use strict";

itsoftApp.createModule("animateScroll", ["windowResize", "startLoad"], function () {
  var module = this;
  var pageHeader = document.querySelector("[data-fixed='true']");
  var viewportSize = itsoftApp.utils.getViewportSize();
  var libraries = {
    smoothScroll: {
      name: "smoothScroll",
      queue: [],
      started: false,
      loaded: false,
      script: "/assets/scripts/smoothScroll/smooth-scroll.min.js"
    }
  };

  var ResponsiveScroll = function ResponsiveScroll(_ref) {
    var target = _ref.target,
        targetTrigger = _ref.targetTrigger,
        clickedScrollFlag = _ref.clickedScrollFlag,
        settings = _ref.settings;
    this.exemplar = "";
    this.targetTrigger = targetTrigger;
    this.target = target;
    this.settings = settings;
    this.clickedScrollFlag = clickedScrollFlag;
    this.defaultPadding = 0;
    this.maxMobileWidth = 1023;
    this.init();
  };

  ResponsiveScroll.prototype.startScroll = function () {
    var RESPONSIVE_SCROLL = this;

    if (pageHeader) {
      if (this.target.hasAttribute("data-offset-sub")) {
        if (viewportSize > this.maxMobileWidth) {
          this.defaultPadding = itsoftApp.commonVars.headerHeight + 48;
        } else {
          this.defaultPadding = itsoftApp.commonVars.headerHeight;
        }
      } else {
        this.defaultPadding = itsoftApp.commonVars.headerHeight;
      }
    }
    /* добавляем отступ сверху, если, например, есть фиксированная шапка */


    this.settings = {
      offset: this.defaultPadding
    };
    /* вычисляем скорость и время, за которое произойдёт прокрутка */

    if (this.speed) {
      this.settings.speed = this.speed;
    }

    this.settings.durationMin = 500;

    if (this.speedAsDuration) {
      this.settings.speedAsDuration = speedAsDuration;
    }

    this.settings.customEasing = function (time) {
      return -(Math.cos(Math.PI * time) - 1) / 2;
    };
    /* Уничтожаем предыдущий экземпляр, если он есть */


    if (this.exemplar) {
      this.exemplar.cancelScroll();
      this.exemplar.destroy();
      this.exemplar = "";
    }

    this.exemplar = new SmoothScroll();

    if (!document.body.classList.contains("is-popup-opened")) {
      this.exemplar.animateScroll(this.target, "auto", this.settings);
    } else {
      setTimeout(function () {
        RESPONSIVE_SCROLL.exemplar.animateScroll(this.target, "auto", this.settings);
      }, 800);
    }
  };

  ResponsiveScroll.prototype.init = function () {
    var RESPONSIVE_SCROLL = this;
    new itsoftApp.modules.startLoad.callback(function () {
      if (!RESPONSIVE_SCROLL.clickedScrollFlag) {
        RESPONSIVE_SCROLL.startScroll();
      } else {
        RESPONSIVE_SCROLL.targetTrigger.addEventListener("click", function (evt) {
          evt.preventDefault();
          var scrollId = evt.currentTarget.href;

          if (!scrollId || !(scrollId = scrollId.split("#")[1])) {
            return;
          }
          /* Находим элемент, до которого нужно прокрутить страницу, и передаём его в функцию */


          RESPONSIVE_SCROLL.target = document.querySelector("#" + scrollId);
          RESPONSIVE_SCROLL.startScroll();
        });
      }
    }, libraries.smoothScroll);
    return true;
  };

  var links = document.querySelectorAll("a[href^='#']:not([href='#'])");
  /* Проходимся по всем элементам, у которых в href есть хэш */

  Array.prototype.forEach.call(links, function (targetTrigger) {
    var clickedScrollFlag = true;
    var newScroll = new ResponsiveScroll({
      targetTrigger: targetTrigger,
      clickedScrollFlag: clickedScrollFlag
    });
  });
  var hash = location.hash;
  var hashElement = hash ? document.querySelector(hash) : null;

  if (hash && hashElement) {
    var target = hashElement;
    new ResponsiveScroll({
      target: target
    });
  }

  module.callback = ResponsiveScroll;
  return module;
});
"use strict";

itsoftApp.createModule("animations", function () {
  var module = this;

  var animate = function animate(options) {
    var start = performance.now();
    requestAnimationFrame(function animate(time) {
      // timeFraction от 0 до 1
      var timeFraction = (time - start) / options.duration;

      if (timeFraction > 1) {
        timeFraction = 1;
      } // текущее состояние анимации


      var progress = options.timing(timeFraction);
      options.draw(progress);

      if (timeFraction < 1) {
        requestAnimationFrame(animate);
      }
    });
  };

  module.callback = animate;
});
// itsoftApp.createModule("checkMenuLink", function () {
//     const module = this;
//     const CheckMenuLink = function () {
//         this.menuLinkElements = document.querySelectorAll(".main-menu__link, .main-menu__sub-link");
//         this.menuItem = null;
//         this.init();
//     };
//     CheckMenuLink.prototype.init = function () {
//         Array.prototype.forEach.call(this.menuLinkElements, function (el) {
//             /* находим все пустые ссылки, кроме тех, где нет решётки, и удаляем атрибут href, чтобы акцентирвать внимание на том, что мы находимся на текущей странице */
//             /* применятся соответствующие стили, например, дял пункта меню, которая ссылается на текущую страницу */
//             /* Нужно доработать на тот случай, если location.pathname == "/", a el.href!="/" */
//             if (el.pathname === location.pathname && el.href !== "#" && ((el.hash === "" && !el.href.includes("#")) || (el.hash !== "" && el.getAttribute("href").includes("/")))) {
//                 this.menuItem = el.parentNode;
//                 this.menuItem.classList.add("is-current");
//                 el.removeAttribute("href");
//             }
//         });
//     };
//     new CheckMenuLink();
//     module.callback = CheckMenuLink;
// });
"use strict";
"use strict";

itsoftApp.createModule("cookie", function () {
  var module = this;

  var Cookie = function Cookie() {
    this.MAX_DATE = 2000000000;
  };

  Cookie.prototype.setCookie = function (element, date, cookieValue) {
    var dAttrSave = element.getAttribute("data-save");
    var dAttrExpires = element.getAttribute("data-expires");

    if (date) {
      document.cookie = dAttrSave + "=yes; path=/; max-age=" + date;
    } else if (dAttrExpires) {
      if (dAttrExpires === "max") {
        dAttrExpires = this.MAX_DATE;
      }

      document.cookie = dAttrSave + "=yes; path=/; max-age=" + dAttrExpires;
    } else {
      document.cookie = dAttrSave + "=yes; path=/";
      /* одна сессия */
    }
  };

  Cookie.prototype.getCookie = function (element) {
    var dAttrSave = element.getAttribute("data-save");
    var matches = document.cookie.match(new RegExp("(?:^|; )" + dAttrSave.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };

  Cookie.prototype.deleteCookie = function (element) {
    this.setCookie(element, {
      "max-age": -1
    }, "");
  };

  var cookieItem = new Cookie();
  module.setCookie = cookieItem.setCookie;
  module.getCookie = cookieItem.getCookie;
  module.deleteCookie = cookieItem.deleteCookie;
});
"use strict";

/**
 * Кнопки в левом нижнем углу экрана
 * (только в режиме dev)
 *
 * NOTE: Код подключается с доп. командой DEBUG && -
 * это значит, что при минификации скриптов
 * данный модуль будет целиком вырезан, и можно не париться насчёт лишних килобайтов.
 */
DEBUG && itsoftApp.createModule("devBtns", function () {
  var module = this;

  var DevBtns = function DevBtns() {
    this.links = document.querySelectorAll("link");
    this.toggled = false;
    this.init();
  };
  /**
   * Отображение без стилей
   * (полезно для проверки чистой разметки, заголовков, секций и т. п.)
   */


  DevBtns.prototype.checkStyles = function () {
    var link, i, media;

    if (!this.toggled) {
      for (i = this.links.length - 1; i >= 0; i--) {
        link = this.links[i];
        media = link.getAttribute("media");

        if (!media) {
          continue;
        }

        link.setAttribute("data-media", media);
        link.setAttribute("media", "none");
      }

      this.toggled = true;
    } else {
      for (i = this.links.length - 1; i >= 0; i--) {
        link = this.links[i];
        media = link.getAttribute("data-media");

        if (!media) {
          continue;
        }

        link.setAttribute("media", media);
        link.removeAttribute("data-media");
      }

      this.toggled = false;
    }
  };

  DevBtns.prototype.setStyles = function () {
    var DEVBTNS = this;
    var btn = document.querySelector(".js-toggle-styles");

    if (!btn) {
      return false;
    }

    this.toggled = false;
    btn.addEventListener("click", DEVBTNS.checkStyles.bind(DEVBTNS), false);
  };
  /**
   * Отображение без изображений,
   * но так, чтобы был виден текст атрибута alt.
   */


  DevBtns.prototype.checkImages = function () {
    var dAttrSrcOri = "data-src-ori";
    var attrSrc = "src";
    var dAttrSrcsetOri = "data-srcset-ori";
    var attrSrcset = "srcset";
    var i, img;
    var images = document.querySelectorAll("img, source");
    /* находим все изображения, чтобы можно было у них убрать значение атрибута src или srcset */

    /* тем самым мы можем опредлить, из-за каих картинок скачет страница */

    for (i = images.length - 1; i >= 0; i--) {
      img = images[i];

      if (!this.toggled) {
        if (img.hasAttribute(attrSrc)) {
          img.setAttribute(dAttrSrcOri, img.getAttribute(attrSrc));
          img.removeAttribute(attrSrc);
        }

        if (img.hasAttribute(attrSrcset)) {
          img.setAttribute(dAttrSrcsetOri, img.getAttribute(attrSrcset));
          img.removeAttribute(attrSrcset);
        }
      } else {
        if (img.hasAttribute(dAttrSrcOri)) {
          img.setAttribute(attrSrc, img.getAttribute(dAttrSrcOri));
          img.removeAttribute(dAttrSrcOri);
        }

        if (img.hasAttribute(dAttrSrcsetOri)) {
          img.setAttribute(attrSrcset, img.getAttribute(dAttrSrcsetOri));
          img.removeAttribute(dAttrSrcsetOri);
        }
      }
    }

    this.toggled = !this.toggled;
  };

  DevBtns.prototype.setImages = function () {
    var DEVBTNS = this;
    var btn = document.querySelector(".js-toggle-images");

    if (!btn) {
      return false;
    }

    btn.addEventListener("click", DEVBTNS.checkImages.bind(DEVBTNS), false);
  };

  DevBtns.prototype.setListeners = function () {
    this.setStyles();
    this.setImages();
  };

  DevBtns.prototype.init = function () {
    if (!document.querySelector(".js-toggle-styles") && !document.querySelector(".js-toggle-images")) {
      return false;
    }

    this.setListeners();
  };

  new DevBtns();
  module.callback = DevBtns;
});
"use strict";

itsoftApp.createModule("disclaimer", ["windowResize", "pageLoad", "cookie"], function () {
  var module = this;

  var Disclaimer = function Disclaimer() {
    this.footer = document.querySelector(".page-footer");
    this.disclaimer = document.querySelector(".js-disclaimer");
    /* У дисклеймера должен быть такой класс */

    this.button = document.querySelector(".disclaimer__close-button");
    /* Крестик */

    this.confirm = document.querySelector(".disclaimer__confirm");
    /* элемент подтвеждения закрытия */

    this.text = document.querySelector(".disclaimer__text");
    this.disclaimerParts = document.querySelectorAll(".disclaimer__part");
    this.footerCoordY;
    this.sTop;
    this.requiredPercentage = 5;
    this.init();
  };

  Disclaimer.prototype.buttonMouseOver = function () {
    var DISCLAIMER = this;

    if (!this.disclaimer.classList.contains("js-hover")) {
      this.disclaimer.classList.add("js-hover");

      if (this.confirm) {
        this.confirm.addEventListener("mouseout", DISCLAIMER.buttonMouseOut.bind(DISCLAIMER));
      }
    }
  };

  Disclaimer.prototype.buttonMouseOut = function () {
    var DISCLAIMER = this;
    this.disclaimer.classList.remove("js-hover");
    this.confirm.removeEventListener("mouseout", DISCLAIMER.buttonMouseOut.bind(DISCLAIMER));
  };

  Disclaimer.prototype.close = function () {
    var DISCLAIMER = this;
    itsoftApp.modules.cookie.setCookie(DISCLAIMER.disclaimer, 86400);
    this.disclaimer.classList.add("js-static");
    this.disclaimer.classList.add("js-inactive");

    if (this.disclaimer.classList.contains("js-hover")) {
      this.disclaimer.classList.remove("js-hover");
    }

    if (this.confirm) {
      this.confirm.style.display = "none";
    }

    this.footer.classList.add("js-update");
  };

  Disclaimer.prototype.checkButton = function () {
    var DISCLAIMER = this;

    if (DISCLAIMER.button) {
      DISCLAIMER.button.addEventListener("mouseover", DISCLAIMER.buttonMouseOver.bind(DISCLAIMER));
      DISCLAIMER.button.addEventListener("click", function (evt) {
        evt.preventDefault();
        this.close = DISCLAIMER.close();
      });
    }
  };

  Disclaimer.prototype.checkConfirm = function () {
    var DISCLAIMER = this;

    if (DISCLAIMER.confirm) {
      DISCLAIMER.confirm.addEventListener("click", function (evt) {
        evt.preventDefault();
        this.close = DISCLAIMER.close();
      });
    }
  };

  Disclaimer.prototype.defineCoordY = function () {
    var DISCLAIMER = this;
    DISCLAIMER.footerCoordY = DISCLAIMER.footer.getBoundingClientRect().top + pageYOffset;
  };
  /* Вычисляем координаты. Если мы прокрутили страницу до подвала, делаем дисклеймер статичным */


  Disclaimer.prototype.checkElementCoords = function () {
    var DISCLAIMER = this;
    this.sTop = pageYOffset;

    if (this.sTop + document.documentElement.clientHeight > this.footerCoordY) {
      if (this.button) {
        this.button.classList.add("js-close-hide");
      }

      this.disclaimer.classList.add("js-inactive");
    } else if (!this.disclaimer.classList.contains("js-static")) {
      if (this.button) {
        this.button.classList.remove("js-close-hide");
      }

      this.disclaimer.classList.remove("js-inactive");
    } else {
      document.removeEventListener("scroll", DISCLAIMER.onDocumentScroll.bind(DISCLAIMER));
      window.removeEventListener("resize", DISCLAIMER.onDocumentResize.bind(DISCLAIMER));
    }
  };

  Disclaimer.prototype.onDocumentScroll = function () {
    var DISCLAIMER = this;
    DISCLAIMER.checkElementCoords();
  };

  Disclaimer.prototype.onDocumentResize = function () {
    /* Обновляем координаты при ресайзе */
    var DISCLAIMER = this;
    DISCLAIMER.calcFontSize();
    DISCLAIMER.defineCoordY();
    DISCLAIMER.checkElementCoords();
  };

  Disclaimer.prototype.init = function () {
    var DISCLAIMER = this;

    if (DISCLAIMER.disclaimer) {
      /* Инициализируем модуль после полной загрузки страницы, только если на странице есть дисклеймер */
      itsoftApp.modules.pageLoad.addEvent(function () {
        var dAttrSave = DISCLAIMER.disclaimer.getAttribute("data-save");
        DISCLAIMER.calcFontSize();

        if (DISCLAIMER.dAttrSave && !itsoftApp.modules.cookie.getCookie(DISCLAIMER.disclaimer)) {
          DISCLAIMER.defineCoordY();
          DISCLAIMER.checkElementCoords();
        } else if (!DISCLAIMER.dAttrSave) {
          DISCLAIMER.defineCoordY();
          DISCLAIMER.checkElementCoords();
        } else {
          return;
        }

        document.addEventListener("scroll", DISCLAIMER.onDocumentScroll.bind(DISCLAIMER));
        window.addEventListener("resize", DISCLAIMER.onDocumentResize.bind(DISCLAIMER));
      });
      DISCLAIMER.checkButton();
      DISCLAIMER.checkConfirm();
    }
  };

  Disclaimer.prototype.getWordsSquare = function () {
    var square = 0;
    Array.prototype.forEach.call(this.disclaimerParts, function (word) {
      var blockW = word.clientWidth;
      var blockH = word.clientHeight;
      var currentSquare = blockW * blockH;
      square += currentSquare;
    });
    return square;
  };

  Disclaimer.prototype.getWindowSquare = function () {
    var bodyWidth = itsoftApp.utils.getViewportSize();
    var bodyHeight = itsoftApp.utils.getViewportHeight();
    return bodyWidth * bodyHeight;
  };

  Disclaimer.prototype.getFinalValue = function (square) {
    var percent = square * 100 / this.getWindowSquare();
    return percent > this.requiredPercentage;
  };

  Disclaimer.prototype.setFontSize = function (size) {
    this.text.style.fontSize = size + "px";
    this.text.setAttribute("data-font-size", size);
  };

  Disclaimer.prototype.getFontSize = function () {
    return parseInt(this.text.getAttribute("data-font-size"), 10) || 8;
  };

  Disclaimer.prototype.calcFontSize = function () {
    var DISCLAIMER = this;
    var counter = 0;
    DISCLAIMER.setFontSize(8);

    while (this.getFinalValue(this.getWordsSquare(), this.requiredPercentage) === false) {
      if (counter++ > 100) break;
      DISCLAIMER.setFontSize(DISCLAIMER.getFontSize() + 2);
    }

    var fontSize = this.getFontSize();
    this.text.style.fontSize = fontSize + "px";
  };

  new Disclaimer();
  module.callback = Disclaimer;
});
"use strict";

itsoftApp.createModule("focusVisible", function () {
  /* Эмулирем на JS псевдокласс focus-visible, так как некоторые браузеры его не поддерживают */

  /* При клике с помощью мышки или пальца не будут срабатывать стили для :focus */
  var module = this;

  var FocusVisible = function FocusVisible() {
    this.path = "/assets/scripts/focus-visible/focus-visible.min.js";
    this.init();
  };

  FocusVisible.prototype.init = function () {
    itsoftApp.loadScript(this.path);
  };

  new FocusVisible();
  module.callback = FocusVisible;
});
"use strict";

itsoftApp.createModule("headerFix", ["pageLoad", "windowScroll", "windowResize"], function () {
  var module = this;

  var Header = function Header() {
    this.header = document.querySelector(".page-header");
    this.pageWrapper = document.querySelector(".l-wrapper");
    this.headerFixed = false;
    this.paddingElems = document.querySelectorAll(".js-padding");
    this.headerHeight;
    this.init();
  };

  Header.prototype.setPagePadding = function () {
    var HEADER = this;

    if (HEADER.paddingElems) {
      Array.prototype.forEach.call(HEADER.paddingElems, function (el) {
        el.style.paddingTop = HEADER.headerHeight + "px";
      });
    } else {
      HEADER.pageWrapper.style.paddingTop = HEADER.headerHeight + "px";
    }
  };

  Header.prototype.updHeaderHeight = function () {
    var HEADER = this;

    if (HEADER.header) {
      HEADER.headerHeight = itsoftApp.utils.getHeaderHeight();
      HEADER.setPagePadding();
    }
  };

  Header.prototype.modifyHeader = function () {
    var HEADER = this;

    if (pageYOffset > 0 && !HEADER.headerFixed) {
      HEADER.header.classList.add("js-fixed");
      HEADER.headerFixed = true;
    } else if (pageYOffset === 0) {
      HEADER.header.classList.remove("js-fixed");
      HEADER.headerFixed = false;
    }
  };

  Header.prototype.init = function () {
    var HEADER = this;

    if (HEADER.header) {
      itsoftApp.modules.pageLoad.addEvent(function () {
        HEADER.headerHeight = itsoftApp.utils.getHeaderHeight();
        itsoftApp.modules.windowResize.addEvent(HEADER.updHeaderHeight.bind(HEADER));
        itsoftApp.modules.windowScroll.addEvent(HEADER.modifyHeader.bind(HEADER));
        HEADER.modifyHeader();
        HEADER.setPagePadding();
      });
    }
  };

  new Header();
  module.callback = Header;
});
"use strict";

itsoftApp.createModule("lazyLoading", function () {
  var module = this;

  var Lazy = function Lazy() {
    this.path = "/assets/scripts/vanilla-lazyload/lazyload.min.js";
    this.settings = "";
    this.init();
  };

  Lazy.prototype.setSettings = function () {
    new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".lazy, .lazyload",
      class_loaded: "loaded"
    });
  };

  Lazy.prototype.init = function () {
    itsoftApp.loadScript(this.path, this.setSettings);
  };

  new Lazy();
  module.callback = Lazy;
});
"use strict";

/* globals Raven */

/**
 * Отмена действия по умолчанию для ссылок с атрибутом href="#".
 * В нашей заготовки таковыми являются ссылки, для которых предполагается реальный href,
 * но который на вёрстке ещё не известен.
 * Если не отменить для таких ссылок действие по умолчанию,
 * то при клике страница перепрыгнет на самый верх, а в адресной строке появится #.
 *
 * NOTE: Также данный модуль отправляет сообщения в логгер, если подобные ссылки
 * найдены на продакт-сервере (там вместо # должны быть проставлены реальные адреса).
 */
itsoftApp.createModule("linksWithHash", function () {
  var module = this;

  var LinksWithHash = function LinksWithHash() {
    this.links = document.querySelectorAll("a[href='#']");
    this.isLocal = itsoftApp.isLocal;
    this.init();
  };
  /**
   * Простой обрабочик, который отменяет действие по умолчанию
   *
   * @param  {object} e Event
   */


  LinksWithHash.prototype.linksWithHashHandler = function (e) {
    e.preventDefault();
    DEBUG && console.log("[module linksWithHash] default action prevented for link");
  }; // Привязка функций к событиям


  LinksWithHash.prototype.addListener = function () {
    var LINKSWITHHASH = this;

    for (var i = 0, len = LINKSWITHHASH.links.length, link; i < len; i++) {
      link = LINKSWITHHASH.links[i];
      link.addEventListener("click", LINKSWITHHASH.linksWithHashHandler.bind(LINKSWITHHASH), false);
    }
  }; // Если на боевом сервере найдены ссылки с атрибутом href="#",
  // то отправляем в логгер сообщение об ошибке,
  // так как там уже должны быть настоящие ссылки вместо заглушек.


  LinksWithHash.prototype.checkRaven = function () {
    if (typeof Raven !== "undefined" && !this.isLocal) {
      var extra = {}; // Формируем объект, в котором перечислены все найденные ссылки,
      // причём с указанием их html-кода
      // (для того, чтобы можно было определить, какие именно ссылки найдены, точно ли это ошибка или нет)

      Array.prototype.forEach.call(this.links, function (link, index) {
        var html = link.outerHTML;
        extra["link" + (index + 1)] = html;
      });
      Raven.captureMessage("[module linksWithHash] links with href='#' found", {
        level: "warning",
        // one of 'info', 'warning', or 'error'
        extra: extra
      });
    }
  };

  LinksWithHash.prototype.init = function () {
    if (!this.links.length) {
      return false;
    }

    DEBUG && console.log("%c[module linksWithHash] " + this.links.length + " links with href='#' found. is it ok for this page?? maybe you need to replace '#' with normal link? check it.", "color: orange");
    this.addListener();
    this.checkRaven();
  };

  new LinksWithHash();
  module.callback = LinksWithHash;
});
"use strict";

/**
 * Мобильное меню
 *
 * NOTE: Модуль можно удалить, если на сайте предусмотрено
 * принципиально иное меню для мобильных устройств.
 */
itsoftApp.createModule("mobMenu", ["windowScroll"], function () {
  var module = this;

  var MobMenu = function MobMenu() {
    this.parentClass = "js-mobmenu";
    this.parent = document.querySelector("." + this.parentClass);
    this.toggleBtns = document.querySelector(".js-mobmenu-toggle");
    this.openedClass = "is-opened";
    this.activeClass = "is-active";
    this.opened = false;
    this.$body = itsoftApp.commonVars.$body;
    this.expandedBlocks = document.querySelector(".js-mobmenu-expand");
    this.fixedPageElems = document.querySelectorAll(".js-page-fixed-elem");
    this.getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
    this.menuLinks = document.querySelectorAll(".js-link");
    this.init();
  };

  MobMenu.prototype.openMenu = function () {
    if (this.opened) {
      return;
    }

    this.opened = true;

    if (this.fixedPageElems) {
      var scrollbarWidth = this.getScrollbarWidth();
      DEBUG && console.log("[module popups] scrollbarWidth: " + scrollbarWidth);
      Array.prototype.forEach.call(this.fixedPageElems, function (el) {
        el.style.paddingRight = scrollbarWidth + "px";
      });
    }

    this.toggleBtns.classList.add(this.activeClass);
    this.parent.classList.add(this.openedClass);
    document.documentElement.style.overflow = "hidden"; // NOTE: Отменил прокрутку

    DEBUG && console.log("[module mobMenu] menu opened");
  };

  MobMenu.prototype.closeMenu = function () {
    if (!this.opened) {
      return;
    }

    this.opened = false;

    if (this.fixedPageElems) {
      Array.prototype.forEach.call(this.fixedPageElems, function (el) {
        el.style.paddingRight = "0";
      });
    }

    document.documentElement.style.overflow = "visible"; // NOTE: Вернул прокрутку

    this.toggleBtns.classList.remove(this.activeClass);
    this.parent.classList.remove(this.openedClass);
    DEBUG && console.log("[module mobMenu] menu closed");
  };

  MobMenu.prototype.toggleBtnClick = function (evt) {
    var MOBMENU = this;
    evt.preventDefault();

    if (this.opened) {
      MOBMENU.closeMenu();
    } else {
      MOBMENU.openMenu();
    }
  };
  /**
   * Обработчик события пролистывания страницы.
   * Мы будем скрывать меню, если пользователь начал листать страницу вниз.
   *
   * @param  {number} y Текущее значение прокрутки страницы
   */


  MobMenu.prototype.scrollController = function (y) {
    var MOBMENU = this;

    if (!this.opened) {
      return;
    } // Значение уже придёт нам из модуля itsoftApp.modules.windowScroll,
    // но на всякий случай пропишем fallback.


    y = typeof y === "number" ? y : document.body.scrollTop || document.documentElement.scrollTop;
    var menuHeight = this.parent.offsetHeight + this.expandedBlocks.offsetHeight; // if (y > menuHeight + 20) {

    if (y + menuHeight > menuHeight + menuHeight / 3) {
      MOBMENU.closeMenu();
    }
  };
  /**
   * Как и в случае со всплывашками на сайте,
   * для меню, если мы видим оставшуюся часть страницы, и кликаем по затемнённой области,
   * то пользователь интуитивно ожидает, что меню закроется.
   * Данный обработчик как раз для этого.
   *
   * @param  {object} e Event
   */


  MobMenu.prototype.bodyClick = function (e) {
    var MOBMENU = this;

    if (!this.opened) {
      return;
    }

    var target = e.target;
    var hasParent = target.closest("." + this.parentClass); // Закрываем меню, только если клик произошёл
    // по элементу вне пределов родительского блока
    // (по сути - клик по любой точке экрана, кроме меню).

    if (!hasParent) {
      MOBMENU.closeMenu(); // Отмена действия по умолчанию
      // (например, чтобы не произошёл переход по ссылке, если
      // мы кликнули по элементу <a>).

      return false;
    }
  };

  MobMenu.prototype.addListeners = function () {
    var MOBMENU = this; // Привязка событий и функций-обработчиков

    this.toggleBtns.addEventListener("click", MOBMENU.toggleBtnClick.bind(MOBMENU));
    this.$body.addEventListener("click", MOBMENU.bodyClick(MOBMENU)); // NOTE: Выловили нелепый баг, на айпадике.
    // Без строчки ниже не срабатывало событие click у верхнего элемента body.
    // Говно, дерьмо, жопа :D

    itsoftApp.commonVars.$wrapper.addEventListener("click", function () {});
    Array.prototype.forEach.call(this.menuLinks, function (el) {
      el.addEventListener("click", function () {
        // if (currentOpenedPopup) {
        //     currentOpenedPopup.dispatchEvent(closeEvent);
        // }
        MOBMENU.closeMenu();
      });
    });
  };

  MobMenu.prototype.init = function () {
    if (!this.parent) {
      return false;
    }

    var MOBMENU = this; // Инициализируем слушатели событий

    this.addListeners(); // Делегируем функцию в модуль windowScroll
    // (единая точка входа для события "scroll").

    DEBUG && console.log("%c--[module mobMenu] delegating scrollController to windowScroll module", "font-style: italic; color: #999");
    itsoftApp.modules.windowScroll.addEvent(MOBMENU.scrollController.bind(MOBMENU));
  };

  new MobMenu();
  module.callback = MobMenu;
});
"use strict";

/**
 * Общая точка входа
 * для события полной загрузки страницы
 * (включая загрузку изображений, метрик и прочего).
 *
 * NOTE: Не путать с событием DOMContentLoaded
 * (оно же - $(document).ready(function() {...}) - в терминах jQuery).
 */
itsoftApp.createModule("pageLoad", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var singleFunctionFired = false;
  var timeoutInit = 120;
  var timeoutDelta = 80;
  var $window = itsoftApp.commonVars.$window;
  var flag = false;
  var body = document.body;
  /**
   * Функция, которая сработает лишь один раз,
   * и будет означать полную загрузку страницы.
   */

  var singleLoadFunction = function singleLoadFunction() {
    var readyState = document.readyState;
    var func, timeoutCurrent;

    if (readyState !== "complete" || singleFunctionFired || !events.length) {
      return false;
    }

    DEBUG && console.log("%c[module pageLoad] window load event fired, count of functions to init: " + events.length + ", timeout for first func: " + timeoutInit + ", timeout delta for other: " + timeoutDelta, "color: purple");

    while (events.length > 0) {
      // Взять первый элемент массива,
      // и передать его в переменную.
      func = events.shift(); // Будем запускать наши отложенные функции
      // через определённые промежутки времени, друг за другом с некоторым промежутком.
      // Мы уже знаем, что это функции,
      // поэтому доп. проверка не требуется.

      timeoutCurrent = timeoutCurrent ? timeoutCurrent + timeoutDelta : timeoutInit;
      setTimeout(func, timeoutCurrent);
    }

    singleFunctionFired = true;

    if (!flag) {
      $window.removeEventListener("load", singleLoadFunction);
      flag = true;
      body.classList.add("js-loaded");

      if (body.hasAttribute("data-no-script")) {
        body.removeAttribute("data-no-script");
      }
    }
  }; // Привязка собитий и функции-обработчика


  if (document.readyState === "complete") {
    singleLoadFunction();
  } else {
    $window.addEventListener("load", singleLoadFunction);
  }
  /**
   * Добавление переданной функции в очередь на выполнение,
   * либо немедленное исполнение функции, если страница уже полностью загружена.
   *
   * @param {function} func
   */


  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    } // Если страница ещё не загружена полность, то добавляем в очередь


    if (!singleFunctionFired) {
      events.push(func);
      DEBUG && console.log("[module pageLoad] function added, count of functions to init now: " + events.length); // Если уже загружена, то просто вызываем переданную функцию
    } else {
      DEBUG && console.log("[module pageLoad] firing function immediately, because window load event already fired");
      func();
    }
  }; // Доступ к фукциям
  // текущего модуля


  module.addEvent = addEvent;
});
// itsoftApp.createModule("picturefill", ["lazyLoadingImages"], function () {
//     itsoftApp.loadScript("/assets/scripts/picturefill/picturefill.min.js");
// })
"use strict";
"use strict";

/**
 * Всплывашки на сайте
 *
 * NOTE: Механизм, позволяющий отменить скролл для страницы, при открытой всплывашке,
 * достаточно хитрый, поэтому лучше изучить данный модуль, чтобы досконально понимать, как он работает
 */
itsoftApp.createModule("popups", ["cookie"], function () {
  var module = this;
  module.$wrapper = document.querySelector(".l-wrapper");
  var popups = document.querySelectorAll("." + "popup"); // this.popupClass

  if (!popups.length) {
    // TODO: Убрать или переделать, чтобы тесты прошли
    return false;
  } // Локальные переменные


  var $body = document.body;
  var $document = document.documentElement;
  var $window = window;
  var activePopups = document.querySelectorAll("[data-bg-opened='true']");
  var popupBox = document.querySelector("#popup-box");
  var fixedPageElems = document.querySelectorAll(".js-page-fixed-elem");
  var hasFixedElems = fixedPageElems.length > 0;
  var staticBackUrl = window.location.pathname;
  var dAttrAutohide = "data-autohide";
  var transitionEventEnd = itsoftApp.features.transitionEventEnd;
  var disabledButtons = document.querySelectorAll(".js-disabled");
  var confirmation = document.querySelector(".js-confirmation");
  var save = document.querySelector(".js-save");
  var slider = {};
  var hashedPopups = document.querySelectorAll("data-hash");
  window.currentOpenedPopup = undefined;
  var getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
  var getScrTop = itsoftApp.utils.getScrTop;
  var currentSlide;
  var activeButton;
  var pageHash;

  if (hashedPopups.length > 0) {
    pageHash = location.hash;
  }

  var Breakpoint = {
    mobile: 320,
    tablet: 768,
    desktop: 1280
  };

  var Popup = function Popup(popup) {
    if (!popup) {
      try {
        throw new Error("Не передан обязательный аргумент popup");
      } catch (err) {}
    }

    this.state = {
      closeButtonsAvailability: false,
      openButtonsAvailability: false,
      initedExemplar: false,
      opened: false
    };
    this.popup = popup;
    this.popupID = popup.id;
    this.openPopupBtnSelector = ".js-open-popup[data-popup-id='" + popup.id + "']";
    this.closePopupBtnSelector = ".js-close-popup[data-popup-id='" + popup.id + "']";
    this.openPopupBtns = document.querySelectorAll(this.openPopupBtnSelector);
    this.closePopupBtns = document.querySelectorAll(this.closePopupBtnSelector);
    this.popupClass = "popup";
    this.openedClass = "is-opened";
    this.dAttrSelector = "data-popup-selector";
    this.dAttrBgClose = "data-bg-close";
    this.hiddenClass = "g-hidden";
    this.evNameOpen = "popups:open";
    this.evNameClose = "popups:close";
    this.wrapperAbsClass = "is-abs";
    this.wrapperOverflow = "is-over";
    this.popupOpenedClass = "is-popup-opened";
    this.dAttrUrl = "data-url";
    this.dAttrHide = "data-hide";
    this.dAttrClose = "data-close-popup";
    this.hideDelayDefault = 3500;
    this.init();
  };

  Popup.prototype.globalState = {
    listenersAdded: false,
    historyPushed: false
  };
  Popup.prototype.openedPopups = [];
  Popup.prototype.autohidePopups = [].filter.call(popups, function (el) {
    return el.matches("[" + dAttrAutohide + "='true']");
  });
  Popup.prototype.lastOpenedPopup = null;

  Popup.prototype.detachEvents = function () {
    this.popup.removeEventListener(this.evNameOpen, this.popupOpen);
    this.popup.removeEventListener(this.evNameClose, this.popupClose);
    this.popup.removeEventListener("click", this.popupClick);
    Array.prototype.forEach.call(this.openPopupBtns, function (openBtn) {
      openBtn.removeEventListener("click", this.openPopupBtnClick);
    });
    Array.prototype.forEach.call(this.closePopupBtns, function (closeBtn) {
      closeBtn.removeEventListener("click", this.closePopupBtnClick);
    });
  };

  Popup.prototype.init = function () {
    var POPUP = this;

    if (!this.globalState.listenersAdded) {
      if (window.CustomEvent && typeof window.CustomEvent === "function") {
        window.closeEvent = new CustomEvent(this.evNameClose, {
          detail: {
            name: "Закрытие"
          }
        });
        window.openEvent = new CustomEvent(this.evNameOpen, {
          detail: {
            name: "Открытие"
          }
        });
      } else {
        window.closeEvent = document.createEvent("CustomEvent");
        window.openEvent = document.createEvent("CustomEvent");
        closeEvent.initCustomEvent(this.evNameClose, true, true, {
          name: "Закрытие"
        });
        openEvent.initCustomEvent(this.evNameOpen, true, true, {
          name: "Открытие"
        });
      }

      window.addEventListener("beforeunload", this.windowUnload);
      window.addEventListener("keyup", this.keyController);
      this.globalState.listenersAdded = true;
    }

    if (this.closePopupBtns.length > 0) {
      this.state.closeButtonsAvailability = true;
    }

    if (this.openPopupBtns.length > 0) {
      this.state.openButtonsAvailability = true;
    }
    /**
     * Клик по кнопкам, открывающим всплывахи.
     * Какую именно всплывашку открыть - обозначено в data- атрибуте.
     */


    Popup.prototype.openPopupBtnClick = function (evt) {
      evt.preventDefault();
      var self = this;
      var dataSlide = self.getAttribute("data-slide"); // const selector = self.getAttribute(POPUP.dAttrSelector);

      dataSlide ? currentSlide = dataSlide : currentSlide = undefined;
      POPUP.popup.dispatchEvent(openEvent);
    };
    /**
     * Клик по кнопкам, закрывающим всплывашку.
     * Будет закрыта "родительская" всплывашка
     * (поиск по ближайшему родителю с нужным классом).
     */


    Popup.prototype.closePopupBtnClick = function () {
      var self = this;
      var checkbox = null; // const popup = self.closest("." + popupClass);

      var onBoxCheck = function onBoxCheck(evt) {
        if (evt.currentTarget.classList.contains("js-error")) {
          checkbox.classList.remove("js-error");
          checkbox.removeEventListener("change", onBoxCheck);
        }
      };

      if (this.classList.contains("js-save")) {
        if (self.hasAttribute("data-checkbox")) {
          var checkboxID = self.getAttribute("data-checkbox");
          checkbox = confirmation.querySelector(checkboxID);

          if (!checkbox.checked) {
            checkbox.classList.add("js-error");
            checkbox.addEventListener("change", onBoxCheck);
            return;
          }
        }

        itsoftApp.modules.cookie.setCookie(this);
      }

      POPUP.popup.dispatchEvent(closeEvent);
    };
    /**
     * Все действия, связанные с открытием всплывашки
     */


    Popup.prototype.popupOpen = function () {
      var self = this;

      if (self.classList.contains(POPUP.openedClass)) {
        return;
      } // Если до этого уже были открыты всплывашки,
      // то вычисляем наибольший z-index, и присваиваем его
      // новой открывающейся всплывашке.
      // Иначе возможны ситуации, когда всплывашка открылась, но из-за расположения по вёрстке
      // оказалась ниже (за счет одинакового z-index), и в итоге её не видно.


      if (POPUP.openedPopups.length > 0) {
        var maxZI = 0;
        Array.prototype.forEach.call(POPUP.openedPopups, function (el) {
          var popup = el;

          if (popup.getAttribute("data-ignore") === "true") {
            return;
          }

          var zi = parseInt(getComputedStyle(popup)["zIndex"], 10);

          if (isNaN(zi)) {
            zi = 0;
          }

          maxZI = Math.max(maxZI, zi);
        });

        if (maxZI > 0) {
          self.style.zIndex = maxZI + 1;
          DEBUG && console.log("%c--[module popups] added z-index " + (maxZI + 1) + ", because there was another opened popups", "font-style: italic; color: #999");
        }
      } // Вычисляем текущую величину прокрутки страницы
      // (делаем это до того, как будут произведены какие-либо дальнейшие действия).


      var scrTop = getScrTop();
      DEBUG && console.log("[module popups] scrTop: " + scrTop); // Если есть fixed элементы на странице,
      // то задаём им padding-right, равный ширине полосы прокрутки.
      // Без этого такие элементы будут дёргаться,
      // так как в процессе открытия всплывашки слегка меняются общие стили страницы.

      if (hasFixedElems) {
        var scrollbarWidth = getScrollbarWidth();
        DEBUG && console.log("[module popups] scrollbarWidth: " + scrollbarWidth);
        Array.prototype.forEach.call(fixedPageElems, function (el) {
          el.style.paddingRight = scrollbarWidth + "px";
        });
      } // NOTE: Это из-за плашки browser-update,
      // которая задаёт <html> ненулевой margin-top,
      // (в случае, если плашка об устаревшем браузере показана)
      // из-за которого страница "прыгает".


      var mt = parseInt(getComputedStyle($document)["marginTop"], 10);
      var mtExists = !isNaN(mt) && mt !== 0;

      if (mtExists) {
        scrTop -= mt;
      } // Основная магия происходит здесь.
      // Элементу .l-wrapper задаётся класс, который одновременно
      // убирает полосу прокрутки у <body> (так как .l-wrapper теперь position: absolute),
      // и добавляет полосу прокрутки у самого .l-wrapper (за счёт overflow: auto).
      // После этого остаётся прокрутить элемент .l-wrapper до того же значения,
      // которое было до этого у <body> (мы посчитали эту величину ранее).
      // Происходит это достаточно быстро, чтобы пользователь ничего не заметил.


      if (module.$wrapper) {
        module.$wrapper.classList.add(POPUP.wrapperAbsClass);
        module.$wrapper.scrollTop = scrTop;
      } // NOTE: Это из-за плашки browser-update


      if (mtExists) {
        $document.scrollTop = 0;
      } // Это для отсутсвия скролла у <body> в некоторых редких случаях
      // (например, если висит плашка об устаревшем браузере)


      if (!POPUP.popup.hasAttribute("data-scroll")) {
        $body.classList.add(POPUP.popupOpenedClass);
      } // Здесь предусмотрена возможность автоматически скрывать некоторые всплывашки
      // при открытии других всплывашек.
      // Для этого им нужно задать определённый data- атрибут
      // (указан в локальных переменных в начале модуля).


      var autohidePopupsOpened = [].filter.call(POPUP.autohidePopups, function (el) {
        return el.classList.contains("." + POPUP.openedClass);
      });

      if (autohidePopupsOpened.length > 0) {
        DEBUG && console.log("[module popups] hided " + autohidePopupsOpened.length + " popups with " + dAttrAutohide + "=true");
        Array.prototype.forEach.call(autohidePopupsOpened, function (el) {
          el.classList.remove(POPUP.openedClass);
        });
      }

      if (currentOpenedPopup) {
        currentOpenedPopup = undefined;
      } // Далее, делаем нашу всплывашку видимой (за счёт класса)


      self.classList.add(POPUP.openedClass);
      currentOpenedPopup = self;
      POPUP.openedPopups.push(self);
      POPUP.state.opened = true;
      var isIncludeSlider = self.hasAttribute("data-slider");

      if (isIncludeSlider) {
        if (self.getAttribute("data-slider") !== "true") {
          var sliderContainer = self.closest(".js-slider");
          self.setAttribute("data-slider", "true");
          itsoftApp.modules.slidersLibrary.callback(sliderContainer, undefined, undefined, self.getAttribute("data-slider-name"), currentSlide);
        } else {
          itsoftApp.modules.slidersLibrary.slider[self.getAttribute("data-slider-name")].slideTo(+currentSlide);
        }
      }

      if (self.hasAttribute("data-destroy-device")) {
        var onWindowResize = function onWindowResize() {
          if (itsoftApp.utils.getViewportSize() >= Breakpoint[self.getAttribute("data-destroy-device")]) {
            self.dispatchEvent(closeEvent);
            window.removeEventListener("resize", onWindowResize);
          }
        };

        window.addEventListener("resize", onWindowResize);
      } // Здесь предусмотрена возможность
      // закрыть текущую всплывашку через определённый промежуток времени
      // (например, всплывашка с коротким информационным сообщением).
      // Для этого им нужно задать определённый data- атрибут
      // (указан в локальных переменных в начале модуля).


      var hideDelay = self.getAttribute(POPUP.dAttrHide);

      if (hideDelay) {
        hideDelay = parseInt(hideDelay, 10);
        hideDelay = isNaN(hideDelay) ? POPUP.hideDelayDefault : hideDelay;
        setTimeout(function () {
          self.dispatchEvent(closeEvent);
        }, hideDelay);
      } // При необходимости, можно управлять адресной строкой браузера


      var urlToChange = self.getAttribute(POPUP.dAttrUrl);

      if (urlToChange) {
        POPUP.changePageUrl(urlToChange);
      }

      DEBUG && console.log("[module popups] opened popup: " + (self.id ? "#" + self.id : "." + self.className));
    };
    /**
     * Все действия, связанные с закрытием всплывашки
     */


    Popup.prototype.popupClose = function () {
      var self = this;

      if (!POPUP.state.opened) {
        return;
      }

      if (activeButton) {
        /* ??? */
        activeButton.classList.remove("js-active");
        activeButton = undefined;
      }
      /* ??? */


      self.classList.remove(POPUP.openedClass); // Так как вплывашка прилетает не мгновенно, а плавно,
      // то сразу делать возврат страницы к исходному состоянию нельзя
      // (будут видны артефакты, сязанные с переводом полосы прокрутки
      // от body к .l-wrapper и обратно).

      var end = function end() {
        setTimeout(function () {
          POPUP.clearScrollStyles();
        }, 200);

        if (transitionEventEnd) {
          self.removeEventListener(transitionEventEnd, end);
          POPUP.openedPopups.pop();
        }

        POPUP.state.opened = false;
      }; // Для современных браузеров, где работает свойство transition,
      // вешаем обработчик на событие transitionEnd.


      if (transitionEventEnd) {
        self.addEventListener(transitionEventEnd, end); // Для старых браузеров, сразу вызываем функцию.
      } else {
        end();
      } // При необходимости,
      // меняем (возвращаем обратно)
      // адрес в строке браузера.


      var urlToChange = self.getAttribute(POPUP.dAttrUrl);

      if (urlToChange) {
        POPUP.changePageUrl("back");
      }

      DEBUG && console.log("[module popups] closed popup: " + (self.id ? "#" + self.id : "." + self.className));
    };
    /**
     * Возврат страницы к исходному
     * (до того, как была открыта хоть одна всплывшка)
     * состоянию.
     *
     * @param  {boolean} force Часть функционала можно исполнить принудительно
     */


    Popup.prototype.clearScrollStyles = function (force) {
      if (force == null) {
        force = false;
      } // Функция выполнится, если не осталось открытых всплывашек
      // (потому что их может быть несколько, и закрытие одной не означает закрытие всех),
      // либо принудительно (в редких случаях).


      var hasOpenedPopups = POPUP.openedPopups.length > 0;

      if (hasOpenedPopups && !force) {
        return;
      } // Вычисляем текущую величину прокрутки страницы
      // (функция getScrTop достаточно "умная", чтобы посчитать текущий скролл при любом состоянии).
      // Это нужно сделать до того, как произойдут дальнейшие действия.
      // $wrapper.classList.add(wrapperOverflow);


      var scrTop = getScrTop();
      DEBUG && console.log("%c[module popups] (clearScrollStyles) scrTop: " + scrTop + ". force: " + force, "color: #999"); // $wrapper.classList.remove(wrapperOverflow);
      // Возвращаем структурные элементы .l-wrapper и body
      // к исходному состоянию, убираем все необходимые классы.

      if (module.$wrapper) {
        module.$wrapper.classList.remove(POPUP.wrapperAbsClass);
      }

      $body.classList.remove(POPUP.popupOpenedClass); // Если на странице есть fixed элементы,
      // то убираем ранее заданное значение radding-right

      if (hasFixedElems) {
        Array.prototype.forEach.call(fixedPageElems, function (el) {
          el.style.paddingRight = "";
        });
      } // NOTE: Это из-за плашки browser-update


      var mt = parseInt(getComputedStyle($document)["marginTop"], 10);
      var mtExists = !isNaN(mt) && mt !== 0;

      if (mtExists) {
        scrTop += mt;
      } // Наконец, пролистываем body до того значения,
      // который был у .l-wrapper.
      // Происходит это довольно быстро, так что пользователь не заметит разницы.


      $document.scrollTop = scrTop;
    };

    Popup.prototype.popupClick = function (evt) {
      var self = this;

      if (evt.target === self && self.getAttribute(POPUP.dAttrBgClose) !== "false") {
        self.dispatchEvent(closeEvent);
      }
    };

    Popup.prototype.windowUnload = function () {
      POPUP.clearScrollStyles(true);
    };

    Popup.prototype.keyController = function (evt) {
      // Обрабатываем только нажатие на ESC,
      // а все остальные нажатия игнорируем.
      if (evt.keyCode !== 27) {
        return;
      }

      if (!POPUP.openedPopups.length) {
        return;
      }

      var maxZI = 0;
      Array.prototype.forEach.call(POPUP.openedPopups, function (el) {
        var popup = el;
        var zi = parseInt(getComputedStyle(popup)["zIndex"], 10);

        if (isNaN(zi)) {
          zi = 0;
        }

        if (zi >= maxZI) {
          maxZI = zi;
          POPUP.lastOpenedPopup = popup;
        }
      });

      if (!POPUP.lastOpenedPopup) {
        return;
      } // Закрываем только последнюю открытую всплывашку


      if (!POPUP.lastOpenedPopup.hasAttribute("data-save")) {
        POPUP.lastOpenedPopup.dispatchEvent(closeEvent);
      }
    };

    this.popup.addEventListener(POPUP.evNameOpen, POPUP.popupOpen);
    this.popup.addEventListener(POPUP.evNameClose, POPUP.popupClose);
    this.popup.addEventListener("click", POPUP.popupClick);
    Array.prototype.forEach.call(this.openPopupBtns, function (openBtn) {
      openBtn.addEventListener("click", POPUP.openPopupBtnClick);
    });
    Array.prototype.forEach.call(this.closePopupBtns, function (closeBtn) {
      closeBtn.addEventListener("click", POPUP.closePopupBtnClick);
    });

    if (this.popup.getAttribute("data-bg-opened") == "true") {
      console.log("data-bg");
      var dAttrSave = this.popup.getAttribute("data-save");

      if (dAttrSave && !itsoftApp.modules.cookie.getCookie(this.popup)) {
        this.popup.dispatchEvent(openEvent);
      } else if (!dAttrSave) {
        this.popup.dispatchEvent(openEvent);
      } else {
        this.popup.dispatchEvent(closeEvent);
      }
    }

    ;

    if (!this.state.initedExemplar) {
      this.state.initedExemplar = true;
    }
  };

  Popup.prototype.changePageUrl = function (url) {
    // Если браузер не поддерживает работу с историей,
    // то прерываем выполнение функции.
    if (!window.history || typeof window.history.pushState !== "function" || typeof url !== "string") {
      DEBUG && console.log("%c[module popups] !window.history || typeof window.history.pushState != function || typeof url != string", "color: red");
      return;
    } // Переход "вперёд" по истории браузера ...


    if (url !== "back") {
      DEBUG && console.log("%c[module popups] trying to change page url to: " + url, "font-style: italic");
      window.history.pushState(false, false, url);
      this.globalState.historyPushed = true; // ... переход "назад"
    } else {
      // Случай, когда мы до этого открыли всплывашку и перешли "вперёд"
      if (this.globalState.historyPushed) {
        DEBUG && console.log("%c[module popups] trying to go back in history", "font-style: italic");
        window.history.back(); // Случай, когда до этого не было перехода "вперёд"
        // (например, пользователь перешёл по прямой ссылке).
      } else if (typeof this.popupID === "string") {
        var urlToChange = staticBackUrl;
        urlToChange = staticBackUrl.substring(0, staticBackUrl.length - this.popupID.length - 1);
        DEBUG && console.log("%c[module popups] replacing page url to " + urlToChange, "font-style: italic; color: orange");
        window.history.replaceState(false, false, urlToChange);
      }
    }
  };

  Array.prototype.forEach.call(popups, function (popup) {
    new Popup(popup);
  });
  var idYtCount = 0;
  var idImgCount = 0;

  var createYoutubePopup = function createYoutubePopup(videoBlock, videoPlay, videoPause, onPlayButtonClick) {
    var videoSrc = videoBlock.getAttribute("data-video-source");
    var popupElement = document.querySelector('[data-video="' + videoSrc + '"]');

    if (!popupElement) {
      var fragment = document.createDocumentFragment();
      popupElement = document.createElement("div");
      var id = ++idYtCount;
      popupElement.setAttribute("data-video", videoSrc);
      popupElement.className = "popup page__popup popup--video video-popup";
      popupElement.setAttribute("data-autohide", true);
      popupElement.id = "popup-video-yt-" + id;
      var popupContentElement = document.createElement("div");
      popupContentElement.className = "video-popup__content popup__content popup__content--video";
      var videoContainer = document.createElement("div");
      videoContainer.className = "video-popup__container popup__container l-container";
      popupContentElement.appendChild(videoContainer);
      var videoItem = document.createElement("div");
      var videoItemId = "popup-video-place" + id;
      videoItem.id = videoItemId;
      videoItem.className = "video-popup__item";
      videoContainer.appendChild(videoItem);
      popupElement.appendChild(popupContentElement);
      var closeButtonElement = document.createElement("button");
      closeButtonElement.type = "button";
      closeButtonElement.className = "video-popup__close popup__close js-close-popup button";
      var iconCloseElement = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32 0H0V32H32V0ZM20 10.4L21.5787 11.9787L17.5573 16L21.4506 19.8933L19.8719 21.4719L15.9787 17.5787L12.1067 21.4506L10.5281 19.8719L14.4 16L10.4 12L11.9787 10.4213L15.9787 14.4213L20 10.4Z\" fill=\"#1F83DE\"/>\n            </svg>";
      closeButtonElement.innerHTML = iconCloseElement;
      closeButtonElement.addEventListener("click", function () {
        popupElement.dispatchEvent(closeEvent);
      });
      videoContainer.appendChild(closeButtonElement);
      fragment.appendChild(popupElement);
      popupBox.appendChild(fragment);
      popupElement.addEventListener(evNameOpen, popupOpen);
      popupElement.addEventListener(evNameOpen, function () {
        videoPlay();
      });
      popupElement.addEventListener(evNameClose, popupClose);
      popupElement.addEventListener(evNameClose, function () {
        videoPause();
      });
      popupElement.addEventListener("click", popupClick);
    }

    var dataPopup = "#popup-video-yt-" + id;
    videoBlock.setAttribute("data-popup-selector", dataPopup);
    videoBlock.setAttribute("data-video-place", videoItemId);
    videoBlock.addEventListener("click", function (evt) {
      evt.preventDefault();
      popupElement.dispatchEvent(openEvent);
      onPlayButtonClick(dataPopup, videoItem);
    });
  };

  var createImagePopup = function createImagePopup(trigger) {
    var triggerElement = trigger;
    var imageElement = trigger.querySelector("img");
    var imageSource = triggerElement.getAttribute("href");
    var imageSourceRetina = triggerElement.getAttribute("data-href-retina");
    var popupElement = document.querySelector('[data-image="' + imageSource + '"]');

    if (!popupElement) {
      var fragment = document.createDocumentFragment();
      popupElement = document.createElement("div");
      var id = ++idImgCount;
      popupElement.setAttribute("data-image", imageSource);
      popupElement.className = "popup page__popup popup--image";
      popupElement.setAttribute("data-autohide", true);
      popupElement.id = "popup-image-" + id;
      var popupContentElement = document.createElement("div");
      popupContentElement.className = "popup__content popup__content--image";
      var imageContainer = document.createElement("div");
      imageContainer.className = "popup__container l-container";
      popupContentElement.appendChild(imageContainer);
      var imageWrapper = document.createElement("div");
      imageWrapper.className = "popup__wrapper";
      imageContainer.appendChild(imageWrapper);
      var newImageElement = document.createElement("img");
      newImageElement.setAttribute("src", imageSource);

      if (imageSourceRetina) {
        newImageElement.setAttribute("srcset", imageSourceRetina);
      }

      newImageElement.setAttribute("alt", imageElement.getAttribute("alt"));
      imageWrapper.appendChild(newImageElement);
      popupElement.appendChild(popupContentElement);
      var popupTitleText = triggerElement.getAttribute("title");
      var titleElement = document.createElement("p");
      titleElement.className = "popup__label";

      if (popupTitleText) {
        titleElement.textContent = popupTitleText;
        imageContainer.appendChild(titleElement);
      }

      var closeButtonElement = document.createElement("button");
      closeButtonElement.type = "button";
      closeButtonElement.className = "popup__close js-close-popup button";
      var iconCloseElement = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32 0H0V32H32V0ZM20 10.4L21.5787 11.9787L17.5573 16L21.4506 19.8933L19.8719 21.4719L15.9787 17.5787L12.1067 21.4506L10.5281 19.8719L14.4 16L10.4 12L11.9787 10.4213L15.9787 14.4213L20 10.4Z\" fill=\"#1F83DE\"/>\n            </svg>";
      closeButtonElement.innerHTML = iconCloseElement;
      closeButtonElement.addEventListener("click", function () {
        popupElement.dispatchEvent(closeEvent);
      });
      imageWrapper.appendChild(closeButtonElement);
      fragment.appendChild(popupElement);
      popupBox.appendChild(fragment);
      popupElement.addEventListener(evNameOpen, popupOpen);
      popupElement.addEventListener(evNameClose, popupClose);
      popupElement.addEventListener("click", popupClick);
    }

    triggerElement.setAttribute("data-popup-selector", "#popup-image-" + id);
    triggerElement.addEventListener("click", function (evt) {
      evt.preventDefault();
      popupElement.dispatchEvent(openEvent);
    }); // this.removeEventListener("click", onImageClick);
  };

  module.callback = {
    popup: Popup,
    createYoutubePopup: createYoutubePopup,
    createImagePopup: createImagePopup
  };
});
"use strict";

itsoftApp.createModule("scrollActions", ["startLoad"], function () {
  var module = this;
  var registeredPlugin = false;
  var registeredScrollTriggerPlugin = false;
  var headerHeight = itsoftApp.utils.getHeaderHeight();
  var libraries = {
    gsap: {
      name: "gsap",
      queue: [],
      started: false,
      loaded: false,
      scriptMore: "/assets/scripts/gsap/ScrollTrigger.min.js",
      script: "/assets/scripts/gsap/gsap.min.js"
    }
  };
  itsoftApp.modules.windowResize.addEvent(function () {
    headerHeight = itsoftApp.utils.getHeaderHeight();
  });

  var initScrollActions = function initScrollActions(element, scrollTriggerFlag, cb) {
    var initScrollExemplar = function initScrollExemplar() {
      if (!registeredPlugin) {
        registeredPlugin = true;

        if (!registeredScrollTriggerPlugin && scrollTriggerFlag) {
          // регистрируем дополнительный плагин, чтобы анимации работали при скролле
          gsap.registerPlugin(ScrollTrigger);
        }
      }

      if (cb && typeof cb === "function") {
        cb();
      } else {
        if (element.classList.contains("js-clock")) {
          var clockHand = element.querySelector(".js-clock-hand");
          var count = element.querySelector(".js-count");
          var number = count.getAttribute("data-number-target");
          var firstEnterFlag = false;
          ScrollTrigger.create({
            trigger: element,
            start: "top center",
            once: true,
            onEnter: function onEnter() {
              element.classList.add("js-active");
              var options = {
                draw: function draw(progress) {
                  /* анимируем в зависимости от времени и временной функции */
                  count.textContent = parseInt(progress * number, 10);
                },
                timing: function timing(timeFraction) {
                  return 1 - (1 - timeFraction);
                },
                duration: 3000
              };
              itsoftApp.modules.animations.callback(options);
            }
          });
        }

        if (element.classList.contains("js-sequence")) {
          var render = function render() {
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.drawImage(images[pack.frame], 0, 0);
          };

          var canvas = element.querySelector(".js-pack-canvas");
          var context = canvas.getContext("2d");
          canvas.width = 1520;
          canvas.height = 924;
          var frameCount = 7;

          var currentFrame = function currentFrame(index) {
            return "/media/images/sequence/".concat(index + 1, ".png");
          };

          var images = [];
          var pack = {
            frame: 0
          };

          for (var i = 0; i < frameCount; i++) {
            var img = new Image();
            img.src = currentFrame(i);
            images.push(img);
          }

          gsap.to(pack, {
            frame: frameCount - 1,
            snap: "frame",
            ease: "none",
            scrollTrigger: {
              trigger: element,
              scrub: 0.5,
              start: "55% center",
              end: "75% center"
            },
            onUpdate: render // use animation onUpdate instead of scrollTrigger's onUpdate

          });
          images[0].onload = render;
        }

        if (element.classList.contains("js-scroll-parallax")) {
          gsap.to(".js-parallax-item", {
            scrollTrigger: {
              trigger: element,
              scrub: true
            },
            y: function y(i, target) {
              return -ScrollTrigger.maxScroll(window) * target.dataset.speed;
            },
            ease: "none"
          });
        }

        if (element.classList.contains("js-hash-nav")) {
          var setActive = function setActive(link, index) {
            links.forEach(function (el) {
              return el.classList.remove("js-active");
            });
            link.classList.add("js-active");
          };

          var links = gsap.utils.toArray("[data-color]");
          links.forEach(function (a, index) {
            var element = document.querySelector(a.getAttribute("href")); // let linkST = ScrollTrigger.create({
            //     trigger: element,
            //     start: "top top"
            // });

            ScrollTrigger.create({
              trigger: element,
              start: "top top+=140px",
              end: "bottom top+=140px",
              onToggle: function onToggle(self) {
                return self.isActive && setActive(a, index);
              }
            });
          });
        }
      }
    };

    new itsoftApp.modules.startLoad.callback(initScrollExemplar, libraries.gsap);
  };

  module.callback = initScrollActions;
});
"use strict";

itsoftApp.createModule("scrollEffects", ["windowResize", "windowScroll"], function () {
  var module = this;
  var viewWidthEl = document.querySelector(".js-viewport");
  var desktopEl = document.querySelector(".js-desktop");

  if (viewWidthEl || desktopEl) {
    var viewport = itsoftApp.utils.getViewportSize();
    itsoftApp.modules.windowResize.addEvent(function () {
      viewport = itsoftApp.utils.getViewportSize();
    });
  }

  function ScrollEffect(self, classAnimate, oldClass) {
    this._target = self;
    this._classAnimate = classAnimate;
    this._oldClass = oldClass;
    this._scrollPoint;
    this._position = "bottom";

    if (this._target.hasAttribute("data-position")) {
      this._position = this._target.getAttribute("data-position");
    }

    this.init();
  }

  ScrollEffect.prototype.processing = false;

  ScrollEffect.prototype.calculateValue = function () {
    //cb
    if (this._position === "middle") {
      this._positionValue = window.innerHeight / 2;
    } else if (this._position === "top") {
      this._positionValue = 0;
    } else {
      this._positionValue = window.innerHeight;
    }

    return this._positionValue;
  };

  ScrollEffect.prototype.init = function () {
    var self = this;

    self._check = function () {
      //scroll
      var scrolled = pageYOffset; // var coeff;

      self._scrollPoint = parseInt(self._target.getBoundingClientRect().top);

      if (scrolled + self.calculateValue() >= self._scrollPoint + scrolled) {
        /* NOTE: Если равен 0, элемент, скорее всего, скрыт display: none*/
        self.start();
      }
    };

    module.scrollEffectElements.push(self);

    self._check();

    itsoftApp.modules.windowScroll.addEvent(self._check);
  };

  ScrollEffect.prototype.removeOldClass = function () {
    this._target.classList.remove(this._oldClass);

    if (this._classAnimate) {
      this._target.classList.add(this._classAnimate);
    }

    this._oldClass = undefined;
  };

  ScrollEffect.prototype.start = function () {
    if (!this._oldClass && this.processing) {
      return;
    }

    if (!this._target.classList.contains("js-invisible")) {
      return;
    }

    this.processing = true;
    /* Ленивая загрузка скриптов */

    if (this._target.classList.contains("js-slider")) {
      this.removeOldClass();

      var sliderSettingsKey = this._target.getAttribute("data-slider-settings"); // получаем data-атрибут


      var sliderSettingsObject = itsoftApp.modules.slidersSettings.getSettings(sliderSettingsKey); // получаем объект конфига

      if (sliderSettingsKey && sliderSettingsObject) {
        new itsoftApp.modules.slidersLibrary.callback(this._target, sliderSettingsObject);
      } else {
        new itsoftApp.modules.slidersLibrary.callback(this._target);
      }
    }

    if (this._target.classList.contains("js-accordion")) {
      this.removeOldClass();
      new itsoftApp.modules.accordion.callback(this._target);
    }

    if (this._target.classList.contains("js-social")) {
      this.removeOldClass();
      itsoftApp.modules.social.initSocial(this._target);
    }

    if (this._target.classList.contains("js-video")) {
      this.removeOldClass();
      itsoftApp.modules.video.initVideo(this._target);
    }

    if (this._target.classList.contains("js-scroll-trigger")) {
      this.removeOldClass();
      itsoftApp.modules.scrollActions.callback(this._target);
    }

    if (this._target.classList.contains("js-tooltip-section")) {
      this.removeOldClass();
      itsoftApp.modules.tooltip.callback(this._target);
    }
    /* Ленивая загрузка шрифтов */


    if (this._target.classList.contains("page__fw-600")) {
      this.removeOldClass();
      body.classList.add("page--fw-600");
    }

    this.processing = false;
  };

  module.ScrollEffect = ScrollEffect;
  module.scrollEffectElements = [];
});
"use strict";

itsoftApp.createModule("scrollEffectsSettings", ["pageLoad", "scrollEffects"], function () {
  var module = this;

  var ScrollEffectSettings = function ScrollEffectSettings() {
    this.scrollEffect = itsoftApp.modules.scrollEffects.ScrollEffect;
    this.fadeInElems = document.querySelectorAll(".fadeIn");
    this.elemsInvisible = document.querySelectorAll(".js-invisible");
    this.init();
  }; //анимация fadeIn элементов


  ScrollEffectSettings.prototype.initAnimation = function () {
    var SETTINGS = this;
    Array.prototype.forEach.call(this.fadeInElems, function (el) {
      new SETTINGS.scrollEffect(el, "fadeIn--show");
    });
    Array.prototype.forEach.call(this.elemsInvisible, function (el) {
      new SETTINGS.scrollEffect(el, "js-visible", "js-invisible");
    });
  };

  ScrollEffectSettings.prototype.init = function () {
    var SETTINGS = this;
    itsoftApp.modules.pageLoad.addEvent(SETTINGS.initAnimation.bind(SETTINGS));
  };

  new ScrollEffectSettings();
  module.callback = ScrollEffectSettings;
});
"use strict";

/**
 * Общий модуль для всех листалок на сайте.
 * Библиотека загружается по мере необходимости.
 */
itsoftApp.createModule("slidersLibrary", function () {
  /* global Swiper */
  // Локальные переменные
  var module = this;
  var libraries = {
    slider: {
      name: "swiper",
      queue: [],
      started: false,
      loaded: false,
      style: "/assets/scripts/swiper/swiper.min.css",
      script: "/assets/scripts/swiper/swiper.min.js",
      cb: function cb() {
        Swiper.initedSliders = {};
      }
    }
  };

  var Slider = function Slider(el, sliderSettings, cb, currentSlide) {
    this.el = el;
    this.sliderSettings = sliderSettings;
    this.currentSlide = currentSlide;
    this.sliderContainer = el.querySelector(".swiper-container");
    this.navigation = el.querySelector(".swiper-navigation");
    this.pagination = el.querySelector(".swiper-pagination");
    this.scrollbar = el.querySelector(".swiper-scrollbar");
    this.dataDevice = el.getAttribute("data-destroy-device");
    this.destroyDirection = el.getAttribute("data-destroy-direction");
    this.withoutNavigation = el.hasAttribute("data-without-navigation");
    this.withoutPagination = el.hasAttribute("data-without-pagination");
    this.isInitialized = false;
    this.initializedSlider = null;
    this.init();
  };

  Slider.prototype.init = function () {
    var SLIDER = this;

    Slider.prototype.onWindowResize = function () {
      if (SLIDER.destroyDirection === "from" && SLIDER.dataDevice && itsoftApp.utils.getViewportSize() >= +SLIDER.dataDevice) {
        if (SLIDER.isInitialized === true) {
          SLIDER.destroySlider();
        }
      } else if (SLIDER.destroyDirection === "to" && SLIDER.dataDevice && itsoftApp.utils.getViewportSize() <= +SLIDER.dataDevice) {
        if (SLIDER.isInitialized === true) {
          SLIDER.destroySlider();
        }
      } else {
        if (SLIDER.isInitialized === false) {
          SLIDER.initSlider();
        }
      }
    };

    Slider.prototype.createSlider = function () {
      if (!SLIDER.sliderSettings) {
        return;
      }

      if (!SLIDER.withoutNavigation && SLIDER.navigation) {
        var prevBtn = SLIDER.navigation.querySelector(".js-prev-btn");
        var nextBtn = SLIDER.navigation.querySelector(".js-next-btn");
        SLIDER.sliderSettings.navigation = {};
        SLIDER.sliderSettings.navigation.prevEl = prevBtn;
        SLIDER.sliderSettings.navigation.nextEl = nextBtn;
      }

      if (!SLIDER.withoutPagination && SLIDER.pagination) {
        if (!SLIDER.sliderSettings.pagination) {
          SLIDER.sliderSettings.pagination = {};
        }

        SLIDER.sliderSettings.pagination.el = SLIDER.pagination;

        if (SLIDER.pagination.classList.contains("js-pagination-dots")) {
          SLIDER.sliderSettings.pagination.type = "bullets";
          SLIDER.sliderSettings.pagination.clickable = true;
        } else if (SLIDER.pagination.classList.contains("js-pagination-progress")) {
          SLIDER.sliderSettings.pagination.type = "progressbar";
          SLIDER.sliderSettings.pagination.clickable = true;
        } else {
          SLIDER.sliderSettings.pagination.type = "fraction";

          SLIDER.sliderSettings.pagination.renderFraction = function (currentClass, totalClass) {
            return "<span class='" + currentClass + "'></span>" + "/" + "<span class='" + totalClass + "'></span>";
          };
        }
      }

      if (SLIDER.dataDevice) {
        SLIDER.onWindowResize();
        itsoftApp.modules.windowResize.addEvent(SLIDER.onWindowResize);
      } else {
        SLIDER.initSlider();
      }
    };

    new itsoftApp.modules.startLoad.callback(this.createSlider, libraries.slider);
  };

  Slider.prototype.destroySlider = function () {
    this.initializedSlider.destroy(false, true);
    this.initializedSlider = undefined;
    this.isInitialized = false;
  };

  Slider.prototype.initSlider = function () {
    this.initializedSlider = new Swiper(this.sliderContainer, this.sliderSettings);

    if (this.initializedSlider) {
      if (this.currentSlide) {
        this.initializedSlider.slideTo(+this.currentSlide);
      }

      this.isInitialized = true;
    }
  };

  module.callback = Slider;
});
"use strict";

/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
  // Локальные переменные
  var module = this;
  var Settings = {
    global: {
      slidesPerView: "auto",
      simulateTouch: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      centeredSlides: true,
      followFinger: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      freeModeMomentum: false,
      speed: 500,
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var sliderName = swiperContainer.getAttribute("data-slider-name");

          if (sliderName) {
            Swiper.initedSliders[sliderName] = this;
          }
        }
      }
    },
    hologram: {
      slidesPerView: "auto",
      simulateTouch: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      centeredSlides: true,
      followFinger: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      freeModeMomentum: false,
      speed: 500,
      custom: {
        hurtBalls: null,
        introBallsEl: null,
        clickedBall: null,
        currentBall: null,
        activeDesktopFlag: false,
        toggleActiveElement: function toggleActiveElement(swiper) {
          swiper.params.custom.clickedBall = swiper.params.custom.hurtBalls[swiper.activeIndex];

          if (swiper.params.custom.currentBall) {
            swiper.params.custom.currentBall.classList.remove("js-active");
          }

          swiper.params.custom.clickedBall.classList.add("js-active");
          swiper.params.custom.currentBall = swiper.params.custom.clickedBall;

          if (!swiper.params.custom.introBallsEl.classList.contains("js-active")) {
            swiper.params.custom.introBallsEl.classList.add("js-active");
          }
        }
      },
      on: {
        init: function init() {
          var swiper = this;
          var swiperContainer = swiper.el;
          var sliderName = swiperContainer.getAttribute("data-slider-name") || swiperContainer.closest(".js-slider").getAttribute("data-slider-settings");
          var introCloseButton = document.querySelector(".js-ball-close");
          swiper.params.custom.hurtBalls = document.querySelectorAll(".js-hurt-ball");
          swiper.params.custom.introBallsEl = document.querySelector(".js-balls");
          swiper.params.custom.currentBall = swiper.params.custom.hurtBalls[swiper.activeIndex];
          Array.prototype.forEach.call(swiper.params.custom.hurtBalls, function (ball, index) {
            ball.addEventListener("click", function (evt) {
              evt.preventDefault();

              if (index == swiper.activeIndex) {
                swiper.params.custom.toggleActiveElement(swiper);
                swiper.params.custom.activeDesktopFlag = true;
              }

              swiper.slideTo(index);
            });
          });
          introCloseButton.addEventListener("click", function () {
            swiper.params.custom.introBallsEl.classList.remove("js-active");
            swiper.params.custom.currentBall.classList.remove("js-active");
            swiper.params.custom.currentBall = null;
          });
        },
        slideChange: function slideChange() {
          var swiper = this;
          swiper.params.custom.toggleActiveElement(swiper);
        }
      }
    }
  };

  var getSettings = function getSettings(slidersSettingsKey) {
    return Settings[slidersSettingsKey];
  };

  module.getSettings = getSettings;
});
"use strict";

itsoftApp.createModule("social", ["pageLoad"], function () {
  var module = this;
  var libraries = {
    sharer: {
      name: "likely",
      queue: [],
      started: false,
      loaded: false,
      script: "/assets/scripts/sharer/sharer.min.js"
    }
  };

  var startSocial = function startSocial() {
    var socialButtons = document.querySelectorAll(".js-social-btn");
    Array.prototype.forEach.call(socialButtons, function (button) {
      button.setAttribute("data-url", location.href);
      Sharer.init();
    });
  };

  var initSocial = function initSocial(el) {
    new itsoftApp.modules.startLoad.callback(startSocial, libraries.sharer);
  };

  module.initSocial = initSocial;
});
"use strict";

itsoftApp.createModule("startLoad", ["pageLoad"], function () {
  var module = this;

  var LibraryLoader = function LibraryLoader(func, library) {
    this.func = func;
    this.library = library;
    this.startLoad();
  };

  LibraryLoader.prototype.initQueue = function () {
    var LIBRARY_LOADER = this;

    if (!LIBRARY_LOADER.library.loaded) {
      return false;
    }

    if (!LIBRARY_LOADER.library.queue.length) {
      return;
    }

    DEBUG && console.log("[module" + LIBRARY_LOADER.library.name + "] initQueue function fired, queue.length: " + LIBRARY_LOADER.library.queue.length);

    while (LIBRARY_LOADER.library.queue.length > 0) {
      // Взять первый элемент массива,
      // и вызвать его. Мы уже знаем, что это функция,
      // поэтому доп. проверка не требуется.
      LIBRARY_LOADER.library.queue.shift()();
    }
  };

  LibraryLoader.prototype.loadAndInit = function () {
    var LIBRARY_LOADER = this;

    var f = function f() {
      LIBRARY_LOADER.library.loaded = true;
      LIBRARY_LOADER.initQueue();
    };

    if (LIBRARY_LOADER.library.hasOwnProperty("style")) {
      itsoftApp.loadStyle(LIBRARY_LOADER.library.style);
    }

    itsoftApp.loadScript(LIBRARY_LOADER.library.script, function () {
      DEBUG && console.log("[module" + LIBRARY_LOADER.library.name + "] library loaded, ready to init queue");

      if (LIBRARY_LOADER.library.hasOwnProperty("scriptMore")) {
        itsoftApp.loadScript(LIBRARY_LOADER.library.scriptMore, function () {
          f();
        });
      } else {
        f();
      }
    });
  };

  LibraryLoader.prototype.addEvent = function () {
    var LIBRARY_LOADER = this;

    if (typeof this.func !== "function") {
      return;
    } // Если библиотека ещё не загружена, то добавляем в очередь


    if (!this.library.loaded) {
      // Если библиотека ещё не начала грузиться, то загружаем её
      // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
      if (!this.library.started) {
        this.library.started = true;
        DEBUG && console.log("%c--[module" + this.library.name + "] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
        itsoftApp.modules.pageLoad.addEvent(function () {
          LIBRARY_LOADER.loadAndInit();
        });
      }

      this.library.queue.push(this.func);
      DEBUG && console.log("[module " + this.library.name + "] function added, count of functions to init now: " + this.library.queue.length); // Если библиотека уже загружена, то просто вызываем переданную функцию
    } else {
      if (this.library.cb && typeof this.library.cb === "function") {
        this.library.cb();
      }

      this.func();
    }
  };

  LibraryLoader.prototype.startLoad = function () {
    this.addEvent(this.func);
  }; // Доступ к функциям
  // текущего модуля


  module.callback = LibraryLoader;
});
"use strict";

itsoftApp.createModule("toggleTabs", function () {
  var module = this;

  var Tabs = function Tabs(tabs) {
    this.tabs = tabs;
    this.tabsInitialized = false;
    this.isContainingTabs = this.tabs.hasAttribute("data-tabs-caption");
    /* Содержит ли вкладка дочерние табы */

    this.toggler = this.tabs.querySelector(".js-tabs-list.js-toggle");
    /* находим на странице возможный тогглер */

    this.noHash = this.tabs.hasAttribute("data-no-hash"); // если стоит этот атрибут, табы будут перкеключаться без изменения хэша

    this.tabsItems = []; // все кнопки для переключения вкладок

    this.currentActiveTabs = []; // все активные кнопки для переключения вкладок

    this.currentActiveContents = []; // все активные секции активной вкладки

    this.clickedTab = ""; // кнопка, на которую кликнули в данный момент

    this.clickedTabName = ""; // название кнопки, на которую кликнули

    this.dataActiveSectionClass;
    this.dataActiveSectionSelector;
    this.sectionElement;
    this.toggleFlag = 0;
    this.dataButtons = ""; // Название кнопок табов 

    this.dataSection = ""; // Название секции табов

    this.currentTab = "";
    this.tabSelector = "";
    this.tabsContents = "";
    /* в зависимости от условий */

    this.dataSliderName = "";
    /* название слайдера, который требуется листать при переключении табов */

    this.dataLevel = "";
    /* вложенная секция с табами */

    this.dataLevelValue = "";
    /* название уровня вложенной секции с табами */

    this.dataTabsValue = "";
    /* название уровня списка кнопок во вложенной секции с табами** */

    this.init();
  };

  Tabs.prototype.init = function () {
    if (this.tabs.hasAttribute("data-slider-name")) {
      this.sliderName = this.tabs.getAttribute("data-slider-name");
    }

    if (this.isContainingTabs) {
      this.dataLevel = this.tabs.querySelector("[data-level]");
      this.dataTabsValue = this.tabs.getAttribute("data-tabs-caption");
      this.dataButtons = this.tabs.querySelector("[data-tabs-buttons='" + this.dataTabsValue + "']");
      this.dataSection = this.tabs.querySelector("[data-tabs-section='" + this.dataTabsValue + "']");
    }

    if (this.dataLevel) {
      this.dataLevelValue = this.dataLevel.getAttribute("data-level");
    }

    if (!this.isContainingTabs) {
      this.dataButtons = this.tabs.querySelector(".js-tabs-list");
      this.dataSection = this.tabs.querySelector(".js-tabs-content");
    }

    if (this.dataLevel && this.dataLevelValue === this.dataTabsValue) {
      /* если название указано, находим активные секции только внутри блока с названием табов */
      this.currentActiveContents = this.dataSection.querySelectorAll(".js-tab-content--active[data-level='" + this.dataTabsValue + "']");
    } else {
      /* иначе находим все */
      this.currentActiveContents = this.dataSection.querySelectorAll(".js-tab-content--active");
    }

    this.tabsItems = this.dataButtons.querySelectorAll(".js-tab-name");
    this.currentActiveTabs = this.dataButtons.querySelectorAll(".js-tab-name--active");

    for (var i = 0; i < this.tabsItems.length; i++) {
      this.addTabClickListener(this.tabsItems[i]);
    }

    if (!this.tabsInitialized) {
      this.tabsInitialized = true;

      if (location.hash && !this.noHash) {
        this.goToHash(location.hash);
      }
      /* Этот метод позволяет перейти к любой вкладке по хэшу из другого модуля */


      module.callback.goToHash = this.goToHash;
    }
  };

  Tabs.prototype.goToHash = function (newHash) {
    var element;
    var contentElements;
    var contentSelector;

    if (newHash) {
      newHash = newHash.replace(/^#/, "");
      var selector = "[data-tab-name='" + newHash + "']";
      contentSelector = "[data-content-url='" + newHash + "']";
      element = this.dataButtons.querySelector(selector);
      contentElements = this.dataSection.querySelectorAll(contentSelector);
    } else {
      element = tabsItems[0];
      contentSelector = "[data-content-url='" + element.getAttribute("data-tab-name") + "']";
      contentElements = this.dataSection.querySelectorAll(contentSelector);
    } // DEBUG && console.log("contentElementsHash", contentElements);


    if (element) {
      this.goToTab(element, contentElements);
    }
  };

  Tabs.prototype.goToTab = function (tab, contents) {
    var TABS = this;
    /* Логика переключения к определенному табу */

    this.toggleFlag = 0;

    if (this.tabs.classList.contains("js-init-settings")) {
      this.tabs.classList.remove("js-init-settings");
    }

    this.clickedTab = tab;

    if (!this.clickedTab.classList.contains("js-tab-name--active")) {
      if (this.toggler && !this.toggleFlag) {
        this.toggler.classList.toggle("js-toggle--active");
        this.toggleFlag = 1;
      }
    }

    Array.prototype.forEach.call(this.currentActiveTabs, function (currentActiveTab) {
      currentActiveTab.classList.remove("js-tab-name--active");
    });
    Array.prototype.forEach.call(this.currentActiveContents, function (currentActiveContent) {
      currentActiveContent.classList.remove("js-tab-content--active");
    });

    if (this.dataActiveSectionClass) {
      this.sectionElement.classList.remove(this.dataActiveSectionClass);
    }

    if (dataSliderName) {
      var slideIndex = this.clickedTab.getAttribute("data-slide-to");

      if (itsoftApp.modules.slidersLibrary.sliders[this.sliderName]) {
        itsoftApp.modules.slidersLibrary.sliders[this.sliderName].slideTo(+slideIndex);
      }
    }

    this.clickedTabName = this.clickedTab.getAttribute("data-tab-name");

    if (!this.noHash) {
      location.hash = this.clickedTabName;
    }

    this.currentActiveTabs = this.dataButtons.querySelectorAll("[data-tab-name='" + this.clickedTabName + "']");
    this.dataActiveSectionSelector = tab.getAttribute("data-section-selector");

    if (this.dataActiveSectionSelector) {
      this.sectionElement = this.dataSection.querySelector(this.dataActiveSectionSelector);
    }

    this.dataActiveSectionClass = tab.getAttribute("data-section-class");

    if (this.dataActiveSectionClass) {
      this.sectionElement.classList.add(this.dataActiveSectionClass);
    }

    this.currentActiveContents = contents;
    Array.prototype.forEach.call(this.currentActiveTabs, function (currentActiveTab) {
      currentActiveTab.classList.add("js-tab-name--active");
    });
    Array.prototype.forEach.call(this.currentActiveContents, function (currentActiveContent) {
      var customScroll = currentActiveContent.querySelector(".custom-scroll");

      if (customScroll && !customScroll.classList.contains("js-triggered")) {
        customScroll.classList.add("js-triggered");
        itsoftApp.modules.customScrollbar.callback(customScroll);
      }

      currentActiveContent.classList.add("js-tab-content--active");
    });
    Array.prototype.forEach.call(itsoftApp.modules.scrollEffects.scrollEffectElements, function (scrollEffectElement) {
      scrollEffectElement._check();
    });
  };

  Tabs.prototype.onTabClick = function (currentTab) {
    this.currentTab = currentTab;

    if (this.currentTab.hasAttribute("data-tab-name")) {
      this.tabSelector = this.currentTab.getAttribute("data-tab-name");

      if (!this.noHash) {
        location.hash = this.tabSelector;
      }
    }

    this.tabsContents = this.dataSection.querySelectorAll("[data-content-url='" + this.tabSelector + "']"); // DEBUG && console.log("dataSection", dataSection);
    // DEBUG && console.log("contentElements", tabsContents);
    // После обработки клика передаём элемент, на который произошёл клик, и элемент (вкладка), который должен быть показан универсальной функции goToTab

    if (!this.currentTab.closest(".js-disabled-tabs")) {
      this.goToTab(this.currentTab, this.tabsContents);
    }
  };

  Tabs.prototype.addTabClickListener = function (tab) {
    /* Добавляем обработчик события клика */
    tab.addEventListener("click", function (evt) {
      evt.preventDefault();

      if (!evt.currentTarget.classList.contains("js-tab-name--active")) {
        this.onTabClick(tab);
      } else if (this.tabs.classList.contains("js-init-settings")) {
        this.tabs.classList.remove("js-init-settings");
      }
    }.bind(this));
  };

  module.callback = {};
  module.callback.init = Tabs;
});
"use strict";

itsoftApp.createModule("video", function () {
  var module = this;
  var videoItemEls = document.querySelectorAll(".js-video-item");

  var initVideo = function initVideo(videoEl) {
    var videoBlockWrapper = videoEl.querySelector(".js-video-container");
    var videoItem = videoEl.querySelector(".js-video-item");
    var playButtons = videoEl.querySelectorAll(".js-button-play");

    var onVideoPlay = function onVideoPlay() {
      videoItem.onplay = function () {
        videoItemEls.forEach(function (el) {
          if (el === videoItem) {
            videoItem.play();
          } else {
            el.pause();
          }
        });
      };

      videoItem.play();
      videoItem.classList.add("js-active");
      videoBlockWrapper.classList.add("js-active");
    };

    playButtons.forEach(function (playButton) {
      playButton.addEventListener("click", onVideoPlay);
    });
  };

  module.initVideo = initVideo;
});
"use strict";

/**
 * Общая точка входа
 * для события изменения размеров экрана.
 *
 * NOTE: Событие на практике происходит редко
 * (например, поворот планшета или телефона, или равзернуть окно на полный экран на десктопе),
 * поэтому мы будем "выполнять" его с помощью debouncer
 * (отложенное выполнение).
 */
itsoftApp.createModule("windowResize", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var $window = itsoftApp.commonVars.$window;
  var pageHeader = document.querySelector("[data-fixed='true']");
  /**
   * Основной обработчик,
   * который проходит по всем функциям из массива events
   * и выполняет их.
   *
   * Вызываем обработчик через debouncer (задержка по выполнению),
   * чтобы функции из массива не вызывались слишком часто.
   */

  var resizeController = itsoftApp.utils.debouncer(function () {
    if (!events.length) {
      return;
    }

    var f, i, len;

    if (pageHeader) {
      itsoftApp.utils.getHeaderHeight();
    }

    itsoftApp.utils.getViewportSize();
    itsoftApp.utils.getViewportHeight();

    for (i = 0, len = events.length; i < len; i++) {
      f = events[i];
      f();
    }
  });
  /**
   * Добавление переданной функции в массив всех функций,
   * которые будут вызваны при срабатывании события "resize" окна браузера.
   *
   * @param {function} func
   */

  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    }

    events.push(func);
    DEBUG && console.log("[module windowResize] function added, count of functions to init now: " + events.length);
  }; // Привязка события и обработчика


  $window.addEventListener("resize", resizeController); // Доступ к фукциям
  // текущего модуля

  module.addEvent = addEvent;
});
"use strict";

/**
 * Общая точка входа
 * для события скролла страницы.
 *
 * NOTE: Контроллер будет передавать текущее значение скролла
 * каждой из переданных в данный модуль функций.
 */
itsoftApp.createModule("windowScroll", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var enabled = false;
  var $window = itsoftApp.commonVars.$window;
  /**
   * Основной обработчик,
   * который проходит по всем функциям из массива events
   * и выполняет их.
   */

  var scrollController = function scrollController() {
    if (!enabled) {
      return;
    }

    var y = document.body.scrollTop || document.documentElement.scrollTop;
    var f, i, len;

    for (i = 0, len = events.length; i < len; i++) {
      f = events[i];
      f.call(this, y);
    }
  };
  /**
   * Привязка события и контроллера.
   * Вынесено в отдельную функцию, так как если модулю не передана ни одна функция на событие "scroll"
   * то и общий обработчик вешать нет смысла.
   * Сделано для оптимизации производительности (небольшая прибавка).
   */


  var bind = function bind() {
    $window.addEventListener("scroll", scrollController);
  };
  /**
   * Добавление переданной функции в массив всех функций,
   * которые будут вызваны при срабатывании события "scroll".
   *
   * @param {function} func
   */


  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    }

    if (!enabled) {
      enabled = true;
      bind();
    }

    events.push(func);
    DEBUG && console.log("[module windowScroll] function added, count of functions to init now: " + events.length);
  }; // Доступ к фукциям
  // текущего модуля


  module.addEvent = addEvent;
});